export const contentLists = {
  //end of faq full forms
  sections: {

    postEditLink: 'dashboard/sections/update/',
    backLink: '/content-manager/sections',
    hasBackLink: true,
    hasArabic: true,
    hasAddButton: false,
    hasGroupButtons: false,
    hasCommon: false,
    hasHidden: true,
    hasCategoryAdd:false,
    hasExportButton: false,
    columns: ['title', 'title_ar', 'editPage'],
    titles: ['Title', 'Arabic Title', 'Edit FAQ'],

    edit_form: {

      english: [
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: false,
        },
        {
          label: 'Subtitle',
          name: 'subtitle',
          type: 'text',
          value: '',
          required: false,
        },
        {
          label: 'Description',
          name: 'description',
          type: 'textarea',
          value: '',
          required: false,
        },

        {
          label: 'Short Description',
          name: 'short_description',
          type: 'textarea',
          value: '',
          required: false,
        },
        {
          label:'Media',
          name:'media',
          type:'file',
          value:'',
          required: false,
        },
        {
          label: 'Media Title',
          name: 'media_title',
          type: 'text',
          value: '',
          required: false,
        },

          {
          label: 'Use Different media for Arabic Version.',
          name: 'is_media_different',
          type: 'radio',
          value: '',
          related_to:['media','media_ar'],
          required: false,
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },
        {
          label: 'Icon',
          name: 'icon',
          type: 'file',
          value: '',
          required: false,
        },


        {
          label: 'Use Different Icon for Arabic Version.',
          name: 'is_icon_different',
          type: 'radio',
          value: '',
          required: false,
          related_to:['icon','icon_ar'],
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },
        {
          label:'Dark Image',
          name:'dark_image',
          type:'file',
          value:'',
          required: false,
        },
       {
          label: 'Use Different Dark Image for Arabic Version.',
          name: 'is_dark_image_different',
          type: 'radio',
          value: '',
          related_to:['image','image_ar'],
          required: false,
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },
        {
          label: 'Link',
          name: 'url',
          type: 'text',
          value: '',
          required: false,
        },
      ],
      arabic: [
        {
          label: 'Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: false,
        },
        {
          label: 'Subtitle',
          name: 'subtitle_ar',
          type: 'text',
          value: '',
          required: false,
        },
        {
          label: 'Media Title Arabic',
          name: 'media_title_ar',
          type: 'text',
          value: '',
          required: false,
        },
        {
          label: 'Description',
          name: 'description_ar',
          type: 'textarea',
          value: '',
          required: false,
        },
        {
          label: 'Image',
          name: 'image_ar',
          type: 'file',
          value: '',
          required: false,
        },
        {
          label: 'Short Description',
          name: 'short_description_ar',
          type: 'textarea',
          value: '',
          required: false,
        },
        {
          label:'Media',
          name:'media_ar',
          type:'file',
          value:'',
          required: false,
        },
        {
          label:'Dark Image',
          name:'dark_image_ar',
          type:'file',
          value:'',
          required: false,
        },
        {
          label: 'Icon',
          name: 'icon_ar',
          type: 'file',
          value: '',
          required: false,
        },

        {
          label: 'Icon Caption',
          name: 'image_caption_ar',
          type: 'text',
          value: '',
          required: false,
        },

      ],
      hidden: [
        {
          label: 'subpage_id',
          name: 'subpage_id',
          type: 'hidden',
          value: '',
          required: true,
        },
        {
          label: 'id',
          name: 'id',
          type: 'hidden',
          value: '',
          required: true,
        },
        {
          label: 'type',
          name: 'type',
          type: 'hidden',
          value: 'none',
          required: true,
        },
        {
          label: 'is_visible',
          name: 'is_visible',
          type: 'hidden',
          value: '',
          required: true,
        },

        {
          label: 'order',
          name: 'order',
          type: 'hidden',
          value: 0,
          required: true,
        },
      ],
     common: [],
    },
  },
  offers_sections: {

    postEditLink: 'dashboard/offers_sections/update/',
    backLink: '/content-manager/sections',
    hasBackLink: true,
    hasArabic: true,
    hasAddButton: false,
    hasGroupButtons: false,
    hasCommon: false,
    hasHidden: true,
    hasCategoryAdd:false,
    hasExportButton: false,
    columns: ['title', 'title_ar', 'editPage'],
    titles: ['Title', 'Arabic Title', 'Edit FAQ'],

    edit_form: {

      english: [
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: false,
        },
        {
          label: 'Subtitle',
          name: 'subtitle',
          type: 'text',
          value: '',
          required: false,
        },
        {
          label: 'Description',
          name: 'description',
          type: 'textarea',
          value: '',
          required: false,
        },

       
        {
          label:'Media',
          name:'media',
          type:'file',
          value:'',
          required: false,
        },
        {
          label: 'Media Title',
          name: 'media_title',
          type: 'text',
          value: '',
          required: false,
        },

         
        {
          label: 'Icon',
          name: 'icon',
          type: 'file',
          value: '',
          required: true,
        },

        {
          label: 'Link',
          name: 'url',
          type: 'text',
          value: '',
          required: false,
        },
      ],
      arabic: [
        {
          label: 'Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: false,
        },
        {
          label: 'Subtitle',
          name: 'subtitle_ar',
          type: 'text',
          value: '',
          required: false,
        },
        {
          label: 'Media Title Arabic',
          name: 'media_title_ar',
          type: 'text',
          value: '',
          required: false,
        },
        {
          label: 'Description',
          name: 'description_ar',
          type: 'textarea',
          value: '',
          required: false,
        },
        {
          label: 'Media',
          name: 'media_ar',
          type: 'file',
          value: '',
          required: false,
        },
       
       
       
        {
          label: 'Icon',
          name: 'icon_ar',
          type: 'file',
          value: '',
          required: false,
        },

       

      ],
      hidden: [
       
        {
          label: 'id',
          name: 'id',
          type: 'hidden',
          value: '',
          required: true,
        },
       
       

       
      ],
     common: [],
    },
  },
  faqs: {
    link: 'dashboard/categories/faqs/reference',
    getRecordLink: 'dashboard/categories/',
    postEditLink: 'dashboard/categories/update/',
    deleteLink: 'dashboard/categories',
    postAddLink: 'dashboard/categories',
    routerList: '/content-manager/faqs',
    title: 'Frequently Asked Questions Categories',
    backLink: '/content-manager/faqs',
    hasBackLink: true,
    edit_title: 'Edit Category',
    delete_title: 'Delete Category',
    add_title: 'Add Category',
    hasArabic: true,
    hasCommon: false,
    hasHidden: true,
    hasCategoryAdd:false,
    hasAddButton: true,
    hasGroupButtons: false,
    hasExportButton: false, //to add/hide csv export
    columns: ['title', 'title_ar', 'manage_team','editPage'],
    titles: ['Title', 'Arabic Title', 'Category', 'Actions'],
   edit_form: {

      english: [
        {
          label: 'Order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },
      ],
      arabic: [

        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: false,
        },
      ],
      hidden: [
      ],
      common: [],
    }, //end of edit faq
    add_form: {
      // add faq
      english: [
        {
          label: 'Order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },

      ],
      arabic: [
        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: true,
        },

      ],
      hidden: [
        {
          label: 'reference Type',
          name: 'reference_type',
          type: 'text',
          value: 'faqs',
          required: true,
        },
      ],
      common: [

      ],
    },
  },
  faq_category: {
    link: 'dashboard/faqs/elements/',
    getRecordLink: 'dashboard/faqs/',
    postEditLink: 'dashboard/faqs/update/',
    deleteLink: 'dashboard/faqs',
    postAddLink: 'dashboard/faqs',
    backLink: '/content-manager/list/faq_category/',
    routerList: '/content-manager/list/faq_category/',
    hasBackLink: true,
    title: 'Questions',
    edit_title: 'Edit faq',
    delete_title: 'Delete faq',
    add_title: 'Add faq',
    hasCommon: false,
    hasArabic: true,
    hasHidden: true,
    hasAddButton: true,
    hasGroupButtons: false,
    hasExportButton: false,
    hasCategoryAdd:true,
    columns: ['title', 'title_ar', 'editPage'],
    titles: ['Title', 'Arabic Title', 'editPage'],
    edit_form: {

      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },

        {
          label: 'Question',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Answer',
          name: 'description',
          type: 'text',
          value: '',
          required: true,
        },


      ],
      arabic: [

        {
          label: 'Arabic Question',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: false,
        },
        {
          label: 'Arabic Answer',
          name: 'description_ar',
          type: 'text',
          value: '',
          required: false,
        },
      ],
      hidden: [
        {
          label: 'category_id',
          name: 'category_id',
          type: 'hidden',
          value: '',
          required: true,
        },
      ],
      common: [],
    },
    add_form: {
      //Edit of organizational_team
      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },

        {
          label: 'Question',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Answer',
          name: 'description',
          type: 'text',
          value: '',
          required: true,
        },


      ],
      arabic: [

        {
          label: 'Arabic Question',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: false,
        },
        {
          label: 'Arabic Answer',
          name: 'description_ar',
          type: 'text',
          value: '',
          required: false,
        },
      ],
      hidden: [

        {
          label: 'category_id',
          name: 'category_id',
          type: 'hidden',
          value: '',
          required: true,
        },
      ],
       common: [],
    },
  },
  inquiries: {
    //faq
    link: 'dashboard/inquiries',
    searchlink: 'dashboard/inquiries/search',
    getRecordLink: 'dashboard/inquiries',
    postEditLink: 'dashboard/inquiries/update',
    deleteLink: 'dashboard/inquiries',
    postAddLink: 'dashboard/inquiries',
    routerList: '/content-manager/inquiries',
    title: 'Inquiries',
    backLink: '/content-manager/inquiries',
    hasBackLink: true,
    edit_title: 'Edit inquiry',
    delete_title: 'Delete',
    add_title: 'Add Inquiry',
    hasArabic: false,
    hasCommon: false,
    hasHidden: false,
    hasAddButton: false,
    hasGroupButtons: false,
    hasDateSearch: true,
    hasExportButton: true,
    hasExportItem:false, //to add/hide csv export
    exportOptions: {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: false,
      showTitle: false,
      useBom: true,
      headers: [
        'id',
        'first_name',
        'last_name',
        'email',
        'phone',
        'url',
        'created_at',

      ],
    },
    columns: [
      'first_name',
      'last_name',
      'email',
      'phone',
      'message',
      'request',
      'project',
      'url',
      'created_at',
      'deleteOrDetails',
    ],
    titles: [
      'First name',
      'last name',
      'email',
      'phone no.',
      'Message',
      'request',
      'project',
      'link',
      'created at',
      'Action',
    ],
  },
  cali_inquiries: {
    //faq
    link: 'dashboard/cali_inquiries',
    searchlink: 'dashboard/cali_inquiries/search',
    getRecordLink: 'dashboard/cali_inquiries',
    postEditLink: 'dashboard/inquiries/update',
    deleteLink: 'dashboard/cali_inquiries',
    postAddLink: 'dashboard/cali_inquiries',
    routerList: '/content-manager/cali_inquiries',
    title: 'Cali Inquiries',
    backLink: '/content-manager/cali_inquiries',
    hasBackLink: true,
    edit_title: 'Edit inquiry',
    delete_title: 'Delete',
    add_title: 'Add Inquiry',
    hasArabic: false,
    hasCommon: false,
    hasHidden: false,
    hasAddButton: false,
    hasGroupButtons: false,
    hasDateSearch: true,
    hasExportButton: true,
    hasExportItem:false, //to add/hide csv export
    exportOptions: {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: false,
      showTitle: false,
      useBom: true,
      headers: [
        'id',
        'name',
        'inquiry_type',
        'email',
        'phone',
        'unit',
        'time',
        'created_at',

      ],
    },
    columns: [
      'number',
      'name',
      'email',
      'phone',
      'unit',
      'inquiry_type',
      'time',
      'url',
      'created_at',
      'delete',
    ],
    titles: [
      'number',
      'name',
      'email',
      'phone',
      'unit',
      'inquiry type',
      'time',
      'url',
      'created_at',
      'Action',
    ],
  },
  baymount_inquiries: {
    //faq
    link: 'dashboard/baymount_inquiries',
    searchlink: 'dashboard/baymount_inquiries/search',
    getRecordLink: 'dashboard/baymount_inquiries',
    postEditLink: 'dashboard/inquiries/update',
    deleteLink: 'dashboard/baymount_inquiries',
    postAddLink: 'dashboard/baymount_inquiries',
    routerList: '/content-manager/baymount_inquiries',
    title: 'Baymount Inquiries',
    backLink: '/content-manager/baymount_inquiries',
    hasBackLink: true,
    edit_title: 'Edit inquiry',
    delete_title: 'Delete',
    add_title: 'Add Inquiry',
    hasArabic: false,
    hasCommon: false,
    hasHidden: false,
    hasAddButton: false,
    hasGroupButtons: false,
    hasDateSearch: true,
    hasExportButton: true,
    hasExportItem:false, //to add/hide csv export
    exportOptions: {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: false,
      showTitle: false,
      useBom: true,
      headers: [
        'id',
        'name',
        'inquiry_type',
        'email',
        'phone',
        'unit',
        'time',
        'created_at',

      ],
    },
    columns: [
      'number',
      'name',
      'email',
      'phone',
      'unit',
      'inquiry_type',
      'time',
      'url',
      'created_at',
      'delete',
    ],
    titles: [
      'number',
      'name',
      'email',
      'phone',
      'unit',
      'inquiry type',
      'time',
      'url',
      'created_at',
      'Action',
    ],
  },
  admins: {
    //faq
    link: 'dashboard/users',
    getRecordLink: 'dashboard/users/',
    postEditLink:{profile:'dashboard/users/update',password:'dashboard/users/update/password'} ,
    deleteLink: 'dashboard/users',
    postAddLink: 'dashboard/users',
    routerList: '/admins',
    title: 'Admins',
    backLink: 'users/edit/admins',
    hasBackLink: false,
    edit_title: 'Edit Admin',
    delete_title: 'Delete Admin',
    add_title: 'Add Admin',
    hasCommon: false,
    hasHidden: true,
    hasArabic: false,
    hasAddButton: false,
    hasGroupButtons: false,
    hasExportButton: false, //to add/hide csv export
    columns: ['image', 'name', 'email', 'edit'],
    titles: ['Image', 'Name', 'Email', 'Edit'],
      profile: [
        {
          //faq
          label: 'Avatar',
          name: 'image',
          type: 'file',
          value: '',
          required: true,
        },
        {
          label: 'Name',
          name: 'name',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Avatar Title',
          name: 'image_title',
          type: 'text',
          value: '',
          required: true,
        },


      ],
     password:[
      {
        label: 'Old Password',
        name: 'password',
        type: 'password',
        value: '',
        required: true,
      },
      {
        label: 'New Password',
        name: 'new_password',
        type: 'new',
        value: '',
        required: true,
      },
      {
        label: 'Confirm  New Password',
        name: 'new_password_confirmation',
        type: 'confirm',
        value: '',
        required: true,
      },
    ],
      arabic: [],
      hidden: [
        {
          label: 'id',
          name: 'id',
          type: 'hidden',
          value: '',
          required: true,
        },
      ],
      common: [],
       //end of edit faq
    add_form: {
      // add faq
      english: [
        {
          label: 'Avatar',
          name: 'image',
          type: 'file',
          value: '',
          required: true,
        },
        {
          label: 'Name',
          name: 'name',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Avatar Title',
          name: 'image_title',
          type: 'text',
          value: '',
          required: true,
        },

        {
          label: 'Email',
          name: 'email',
          type: 'text',
          value: '',
          required: true,
        },

        {
          label: 'Password',
          name: 'password',
          type: 'password',
          value: '',
          required: true,
        },
        {
          label: 'Confirm Password',
          name: 'confirmPassword',
          type: 'confirm',
          value: '',
          required: true,
        },
     ],
      arabic: [  ],
      hidden: [ ],
      common: [  ],
    },
  },
  home_partners:{

    link: 'dashboard/sections/',
    getRecordLink: 'dashboard/elements/',
    postEditLink: 'dashboard/elements/update/',
    deleteLink: 'dashboard/elements',
    postAddLink: 'dashboard/elements',
    backLink: '/content-manager/list/home_partners/',
    routerList: '/content-manager/list/home_partners/',
    hasBackLink: true,
    title: 'Slides',
    edit_title: 'Edit Slide',
    delete_title: 'Delete Slide',
    add_title: 'Add Slide',
    hasCommon: false,
    hasArabic: true,
    hasHidden: true,
    hasAddButton: true,
    hasCategoryAdd:true,
    hasGroupButtons: false,
    hasExportButton: false,
    columns: ['title', 'title_ar', 'icon', 'editPage'],
    titles: ['Title', 'Arabic Title', 'icon', 'editPage'],
    edit_form: {

      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Icon/Image',
          name: 'icon',
          type: 'file',
          value: '',
          required: true,
        },
        {
          label: 'Media Title',
          name: 'media_title',
          type: 'text',
          value: '',
          required: true,
        },
         {
          label: 'Use Different Icon/Image for Arabic Version.',
          name: 'is_icon_different',
          type: 'radio',
          value: '',
          required: false,
          related_to:['icon','icon_ar'],
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },
        {
          label:'Dark Image',
          name:'dark_image',
          type:'file',
          value:'',
          required: false,
        },
       {
          label: 'Use Different Dark Image for Arabic Version.',
          name: 'is_dark_image_different',
          type: 'radio',
          value: '',
          related_to:['dark_image','dark_image_ar'],
          required: false,
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },
      ],
      arabic: [
        //Edit of Venues
        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Icon/Image',
          name: 'icon_ar',
          type: 'file',
          value: '',
          required: false,
        },
        {
          label: 'Arabic Media Title',
          name: 'media_title_ar',
          type: 'text',
          value: '',
          required: false,
        },
        {
          label: 'Dark Image',
          name: 'dark_image_ar',
          type: 'file',
          value: '',
          required: false,
        },
      ],
      hidden: [
        {
          label: 'id',
          name: 'id',
          type: 'hidden',
          value: '',
          required: true,
        },

        {
          label: 'section_id',
          name: 'section_id',
          type: 'hidden',
          value: 6,
          required: true,
        },
      ],
      common: [],
    },
    add_form: {
      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Icon/Image',
          name: 'icon',
          type: 'file',
          value: '',
          required: true,
        },
        {
          label: 'Media Title',
          name: 'media_title',
          type: 'text',
          value: '',
          required: true,
        },
         {
          label: 'Use Different Icon/Image for Arabic Version.',
          name: 'is_icon_different',
          type: 'radio',
          value: 0,
          required: false,
          related_to:['icon','icon_ar'],
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },
        {
          label:'Dark Image',
          name:'dark_image',
          type:'file',
          value:'',
          required: false,
        },
       {
          label: 'Use Different Dark Image for Arabic Version.',
          name: 'is_dark_image_different',
          type: 'radio',
          value: 0,
          related_to:['dark_image','dark_image_ar'],
          required: false,
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },
      ],
      arabic: [
        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Icon/Image',
          name: 'icon_ar',
          type: 'file',
          value: '',
          required: false,
        },
        {
          label: 'Arabic Media Title',
          name: 'media_title_ar',
          type: 'text',
          value: '',
          required: true,
        },
        {
        label:'Dark Image',
        name:'dark_image_ar',
        type:'file',
        value:'',
        required: false,
      },
      ],
      hidden: [


        {
          label: 'section_id',
          name: 'section_id',
          type: 'hidden',
          value: 6,
          required: true,
        },
      ],
      common: [],
    },
  },
  partners:{

    link: 'dashboard/sections/',
    getRecordLink: 'dashboard/elements/',
    postEditLink: 'dashboard/elements/update/',
    deleteLink: 'dashboard/elements',
    postAddLink: 'dashboard/elements',
    backLink: '/content-manager/list/partners/',
    routerList: '/content-manager/list/partners/',
    hasBackLink: true,
    title: 'Slides',
    edit_title: 'Edit Slide',
    delete_title: 'Delete Slide',
    add_title: 'Add Slide',
    hasCommon: false,
    hasArabic: true,
    hasHidden: true,
    hasAddButton: true,
    hasGroupButtons: false,
    hasCategoryAdd:true,

    hasExportButton: false,
    columns: ['title', 'title_ar', 'icon', 'subtitle', 'subtitle_ar',  'media' ,'editPage'],
    titles: ['Title', 'Arabic Title', 'icon', 'subtitle', 'subtitle ar',  'Articles' ,'editPage'],
    edit_form: {
      //Edit of organizational_team
      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        //Edit of organizational_team
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Subtitle',
          name: 'subtitle',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Description',
          name: 'description',
          type: 'textarea',
          value: '',
          required: true,
        },
        {
          label: 'Icon/Image',
          name: 'icon',
          type: 'file',
          value: '',
          required: true,
        },
        {
          label: 'Use Different Icon/Image for Arabic Version.',
          name: 'is_icon_different',
          type: 'radio',
          value: '',
          related_to:['icon','icon_ar'],
          required: false,
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },
         {
          label:'Dark Image',
          name:'dark_image',
          type:'file',
          value:'',
          required: false,
        },
       {
          label: 'Use Different Dark Image for Arabic Version.',
          name: 'is_dark_image_different',
          type: 'radio',
          value: '',
          required: false,
          related_to:['dark_image','dark_image_ar'],
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },
        {
          label: 'Media',
          name: 'media',
          type: 'file',
          value: '',
          required: true,
        },
        {
          label: 'Media Title',
          name: 'media_title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Use Different Media for Arabic Version.',
          name: 'is_media_different',
          type: 'radio',
          value: '',
          related_to:['media','media_ar'],
          required: false,
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },
        {
          label: 'Link',
          name: 'url',
          type: 'text',
          value: '',
          required: true,
        },
      ],
      arabic: [

        //Edit of organizational_team
        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Arabic Subtitle',
          name: 'subtitle_ar',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Arabic Description',
          name: 'description_ar',
          type: 'textarea',
          value: '',
          required: true,
        },
        {
          label: 'Icon/Image',
          name: 'icon_ar',
          type: 'file',
          value: '',
          required: false,
        },
 {
          label: 'Dark Image',
          name: 'dark_image_ar',
          type: 'file',
          value: '',
          required: false,
        },
        {
          label: 'Media',
          name: 'media_ar',
          type: 'file',
          value: '',
          required: false,
        },
        {
          label: 'Arabic Media Title',
          name: 'media_title_ar',
          type: 'text',
          value: '',
          required: false,
        },

      ],
      hidden: [
        {
          label: 'id',
          name: 'id',
          type: 'hidden',
          value: '',
          required: true,
        },

        {
          label: 'section_id',
          name: 'section_id',
          type: 'hidden',
          value: 7,
          required: true,
        },
      ],
      common: [],
    },
    add_form: {
      //Edit of organizational_team
      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        //Edit of organizational_team
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Subtitle',
          name: 'subtitle',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Description',
          name: 'description',
          type: 'textarea',
          value: '',
          required: true,
        },
        {
          label: 'Icon/Image',
          name: 'icon',
          type: 'file',
          value: '',
          required: true,
        },
        {
          label: 'Use Different Icon/Image for Arabic Version.',
          name: 'is_icon_different',
          type: 'radio',
          value: 0,
          required: false,
          related_to:['icon','icon_ar'],
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },
        {
          label: 'Media',
          name: 'media',
          type: 'file',
          value: '',
          required: true,
        },
        {
          label: 'Media Title',
          name: 'media_title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Use Different Media for Arabic Version.',
          name: 'is_media_different',
          type: 'radio',
          value: 0,
          related_to:['media','media_ar'],
          required: false,
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },
         {
          label:'Dark Image',
          name:'dark_image',
          type:'file',
          value:'',
          required: false,
        },
       {
          label: 'Use Different Dark Image for Arabic Version.',
          name: 'is_dark_image_different',
          type: 'radio',
          value: 0,
          related_to:['dark_image','dark_image_ar'],
          required: false,
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },
        {
          label: 'Link',
          name: 'url',
          type: 'text',
          value: '',
          required: true,
        },
      ],
      arabic: [
        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Arabic Subtitle',
          name: 'subtitle_ar',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Arabic Description',
          name: 'description_ar',
          type: 'textarea',
          value: '',
          required: true,
        },
        {
          label: 'Icon/Image',
          name: 'icon_ar',
          type: 'file',
          value: '',
          required: false,
        },
 {
          label: 'Dark Image',
          name: 'dark_image_ar',
          type: 'file',
          value: '',
          required: false,
        },
        {
          label: 'Media',
          name: 'media_ar',
          type: 'file',
          value: '',
          required: false,
        },
        {
          label: 'Arabic Media Title',
          name: 'media_title_ar',
          type: 'text',
          value: '',
          required: false,
        },

      ],
      hidden: [


        {
          label: 'section_id',
          name: 'section_id',
          type: 'hidden',
          value: 7,
          required: true,
        },
      ],
      common: [],
    },
  },
  home_sister_company:{

    link: 'dashboard/sections/',
    getRecordLink: 'dashboard/elements/',
    postEditLink: 'dashboard/elements/update/',
    deleteLink: 'dashboard/elements',
    postAddLink: 'dashboard/elements',
    backLink: '/content-manager/list/home_sister_company/',
    routerList: '/content-manager/list/home_sister_company/',
    hasBackLink: true,
    title: 'Slides',
    edit_title: 'Edit Slide',
    delete_title: 'Delete Slide',
    add_title: 'Add Slide',
    hasCommon: false,
    hasArabic: true,
    hasHidden: true,
    hasAddButton: true,
    hasCategoryAdd:true,
    hasGroupButtons: false,
    hasExportButton: false,
    maxLength: 4,
    columns: ['title', 'title_ar', 'media', 'editPage'],
    titles: ['Title', 'Arabic Title', 'Media', 'editPage'],
    edit_form: {
      //Edit of organizational_team
      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Media',
          name: 'media',
          type: 'file',
          value: '',
          required: true,
        },
        {
          label: 'Media Title',
          name: 'media_title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Use Different Media for Arabic Version.',
          name: 'is_media_different',
          type: 'radio',
          value: '',
          required: false,
          related_to:['media','media_ar'],
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },
      ],
      arabic: [
        //Edit of Venues

        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: true,
        },

        {
          label: 'Media',
          name: 'media_ar',
          type: 'file',
          value: '',
          required: false,
        },
        {
          label: 'Arabic Media Title',
          name: 'media_title_ar',
          type: 'text',
          value: '',
          required: false,
        },


      ],
      hidden: [
        {
          label: 'id',
          name: 'id',
          type: 'hidden',
          value: '',
          required: true,
        },

        {
          label: 'Section_id',
          name: 'section_id',
          type: 'hidden',
          value: 5,
          required: true,
        },
      ],
      common: [],
    },
    add_form: {
      //Edit of organizational_team
      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Media',
          name: 'media',
          type: 'file',
          value: '',
          required: true,
        },
        {
          label: 'Media title',
          name: 'media_title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Use Different Media for Arabic Version.',
          name: 'is_media_different',
          type: 'radio',
          value: 0,
          required: false,
          related_to:['media','media_ar'],
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },
      ],
      arabic: [
        //Edit of Venues

        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: true,
        },


        {
          label: 'Media',
          name: 'media_ar',
          type: 'file',
          value: '',
          required: false,
        },
        {
          label: 'Arabic Media title',
          name: 'media_title_ar',
          type: 'text',
          value: '',
          required: true,
        },

      ],
      hidden: [

        {
          label: 'Section_id',
          name: 'section_id',
          type: 'hidden',
          value: 5,
          required: true,
        },
      ],
      common: [],
    },
  },
  home_about: {

    link: 'dashboard/sections/',
    getRecordLink: 'dashboard/elements/',
    postEditLink: 'dashboard/elements/update/',
    deleteLink: 'dashboard/elements',
    postAddLink: 'dashboard/elements',
    backLink: '/content-manager/list/home_about/',
    routerList: '/content-manager/list/home_about/',
    hasBackLink: true,
    title: 'Slides',
    edit_title: 'Edit Slide',
    delete_title: 'Delete Slide',
    add_title: 'Add Slide',
    hasCommon: false,
    hasArabic: true,
    hasHidden: true,
    hasAddButton: false,
    hasGroupButtons: false,
    hasCategoryAdd:false,
    hasExportButton: false,
    columns: ['title', 'title_ar', 'subtitle', 'subtitle_ar', 'edit'],
    titles: ['Title', 'Arabic Title', 'subtitle', 'subtitle ar', 'editPage'],
    edit_form: {
      //Edit of organizational_team
      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title ',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Subtitle',
          name: 'subtitle',
          type: 'text',
          value: '',
          required: true,
        },
      ],
      arabic: [
        //Edit of Venues

        {
          label: 'Atabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Arabic Subtitle',
          name: 'subtitle_ar',
          type: 'text',
          value: '',
          required: true,
        },


      ],
      hidden: [
        {
          label: 'id',
          name: 'id',
          type: 'hidden',
          value: '',
          required: true,
        },

        {
          label: 'Section_id',
          name: 'section_id',
          type: 'hidden',
          value: 4,
          required: true,
        },
      ],
      common: [],
    },
    add_form: {
      //Edit of organizational_team
      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        //Edit of organizational_team
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Subtitle',
          name: 'subtitle',
          type: 'text',
          value: '',
          required: true,
        },
      ],
      arabic: [

        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Arabic Subtitle',
          name: 'subtitle_ar',
          type: 'text',
          value: '',
          required: true,
        },
      ],
      hidden: [


        {
          label: 'Section_id',
          name: 'section_id',
          type: 'hidden',
          value: 4,
          required: true,
        },
      ],
      common: [],
    },
  },
  about_values:{

    link: 'dashboard/sections/',
    getRecordLink: 'dashboard/elements/',
    postEditLink: 'dashboard/elements/update/',
    deleteLink: 'dashboard/elements',
    postAddLink: 'dashboard/elements',
    backLink: '/content-manager/list/about_values/',
    routerList: '/content-manager/list/about_values/',
    hasBackLink: true,
    title: 'Slides',
    edit_title: 'Edit Slide',
    delete_title: 'Delete Slide',
    add_title: 'Add Slide',
    hasCommon: false,
    hasArabic: true,
    hasHidden: true,
    hasAddButton: true,
    hasGroupButtons: false,
    hasExportButton: false,
    hasCategoryAdd:true,
    maxLength: 4,
    columns: ['title', 'description', 'editPage'],
    titles: ['Title', 'Description', 'editPage'],
    edit_form: {
      //Edit of organizational_team
      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title ',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Description',
          name: 'description',
          type: 'text',
          value: '',
          required: true,
        },
      ],
      arabic: [
        //Edit of Venues

        {
          label: 'Atabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Arabic Description',
          name: 'description_ar',
          type: 'text',
          value: '',
          required: true,
        },


      ],
      hidden: [
        {
          label: 'id',
          name: 'id',
          type: 'hidden',
          value: '',
          required: true,
        },

        {
          label: 'Section_id',
          name: 'section_id',
          type: 'hidden',
          value: 19,
          required: true,
        },
      ],
      common: [],
    },
    add_form: {
      //Edit of organizational_team
      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        //Edit of organizational_team
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'description',
          name: 'description',
          type: 'text',
          value: '',
          required: true,
        },
      ],
      arabic: [

        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Arabic Description',
          name: 'description_ar',
          type: 'text',
          value: '',
          required: true,
        },
      ],
      hidden: [


        {
          label: 'Section_id',
          name: 'section_id',
          type: 'hidden',
          value: 19,
          required: true,
        },
      ],
      common: [],
    },
  },
  about_directors:{

    link: 'dashboard/sections/',
    getRecordLink: 'dashboard/elements/',
    postEditLink: 'dashboard/elements/update/',
    deleteLink: 'dashboard/elements',
    postAddLink: 'dashboard/elements',
    backLink: '/content-manager/list/about_directors/',
    routerList: '/content-manager/list/about_directors/',
    hasBackLink: true,
    title: 'Slides',
    edit_title: 'Edit Slide',
    delete_title: 'Delete Slide',
    add_title: 'Add Slide',
    hasCommon: false,
    hasArabic: true,
    hasHidden: true,
    hasAddButton: true,
    hasGroupButtons: false,
    hasCategoryAdd:true,
    hasExportButton: false,
    columns: ['title', 'description', 'media', 'editPage'],
    titles: ['Title', 'Description', 'Media', 'editPage'],
    edit_form: {
      //Edit of organizational_team
      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title ',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Description',
          name: 'description',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Media',
          name: 'media',
          type: 'file',
          value: '',
          required: true,
        },
        {
          label: 'Media Title',
          name: 'media_title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Use Different Media for Arabic Version.',
          name: 'is_media_different',
          type: 'radio',
          value: '',
          required: false,
          related_to:['media','media_ar'],
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },
      ],
      arabic: [
        //Edit of Venues

        {
          label: 'Arabic Title ',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Arabic Description',
          name: 'description_ar',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Media',
          name: 'media_ar',
          type: 'file',
          value: '',
          required: false,
        },
        {
          label: 'Arabic Media Title',
          name: 'media_title_ar',
          type: 'text',
          value: '',
          required: false,
        },


      ],
      hidden: [
        {
          label: 'id',
          name: 'id',
          type: 'hidden',
          value: '',
          required: true,
        },

        {
          label: 'Section_id',
          name: 'section_id',
          type: 'hidden',
          value: 22,
          required: true,
        },
      ],
      common: [],
    },
    add_form: {
      //Edit of organizational_team
      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title ',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Description',
          name: 'description',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Media',
          name: 'media',
          type: 'file',
          value: '',
          required: true,
        },
        {
          label: 'Media Title',
          name: 'media_title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Use Different Media for Arabic Version.',
          name: 'is_media_different',
          type: 'radio',
          value: 0,
          required: false,
          related_to:['media','media_ar'],
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },
      ],
      arabic: [

        {
          label: 'Arabic Title ',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Arabic Description',
          name: 'description_ar',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Media',
          name: 'media_ar',
          type: 'file',
          value: '',
          required: false,
        },
        {
          label: 'Arabic Media Title',
          name: 'media_title_ar',
          type: 'text',
          value: '',
          required: true,
        },

      ],
      hidden: [


        {
          label: 'Section_id',
          name: 'section_id',
          type: 'hidden',
          value: 22,
          required: true,
        },
      ],
      common: [],
    },
  },
  contact_addresses:{

    link: 'dashboard/sections/',
    getRecordLink: 'dashboard/elements/',
    postEditLink: 'dashboard/elements/update/',
    deleteLink: 'dashboard/elements',
    postAddLink: 'dashboard/elements',
    backLink: '/content-manager/list/contact_addresses/',
    routerList: '/content-manager/list/contact_addresses/',
    hasBackLink: true,
    title: 'Slides',
    edit_title: 'Edit Slide',
    delete_title: 'Delete Slide',
    add_title: 'Add Slide',
    hasCommon: false,
    hasArabic: true,
    hasHidden: true,
    hasAddButton: true,
    hasGroupButtons: false,
    hasCategoryAdd:true,
    hasExportButton: false,
    columns: ['title', 'description', 'editPage'],
    titles: ['Title', 'Description', 'editPage'],
    edit_form: {
      //Edit of organizational_team
      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Description',
          name: 'description',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Map',
          name: 'short_description',
          type: 'text',
          value: '',
          required: true,
        },
      ],
      arabic: [
        //Edit of Venues

        {
          label: 'Arabic Title ',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Arabic Description',
          name: 'description_ar',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Map',
          name: 'short_description_ar',
          type: 'text',
          value: '',
          required: true,
        },


      ],
      hidden: [
        {
          label: 'id',
          name: 'id',
          type: 'hidden',
          value: '',
          required: true,
        },

        {
          label: 'Section_id',
          name: 'section_id',
          type: 'hidden',
          value: 25,
          required: true,
        },
      ],
      common: [],
    },
    add_form: {
      //Edit of organizational_team
      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title ',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Description',
          name: 'description',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Map',
          name: 'short_description',
          type: 'text',
          value: '',
          required: true,
        },

      ],
      arabic: [

        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Arabic Description',
          name: 'description_ar',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Map',
          name: 'short_description_ar',
          type: 'text',
          value: '',
          required: true,
        },
      ],
      hidden: [


        {
          label: 'Section_id',
          name: 'section_id',
          type: 'hidden',
          value: 25,
          required: true,
        },
      ],
      common: [],
    },
  },

  contact_projects:{

    link: 'dashboard/sections/',
    getRecordLink: 'dashboard/elements/',
    postEditLink: 'dashboard/elements/update/',
    deleteLink: 'dashboard/elements',
    postAddLink: 'dashboard/elements',
    backLink: '/content-manager/list/contact_projects/',
    routerList: '/content-manager/list/contact_projects/',
    hasBackLink: true,
    title: 'Slides',
    edit_title: 'Edit Slide',
    delete_title: 'Delete Slide',
    add_title: 'Add Slide',
    hasCommon: false,
    hasArabic: true,
    hasHidden: true,
    hasAddButton: true,
    hasGroupButtons: false,
    hasCategoryAdd:true,
    hasExportButton: false,
    columns: ['title', 'title_ar', 'editPage'],
    titles: ['Title', 'Arabiv title', 'editPage'],
    edit_form: {

      //Edit of organizational_team
      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title ',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },

      ],
      arabic: [
        //Edit of Venues

        {
          label: 'Arabic Title ',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: true,
        },


      ],
      hidden: [
        {
          label: 'id',
          name: 'id',
          type: 'hidden',
          value: '',
          required: true,
        },

        {
          label: 'Section_id',
          name: 'section_id',
          type: 'hidden',
          value: 25,
          required: true,
        },
      ],
      common: [],
    },
    add_form: {
      //Edit of organizational_team
      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title ',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },


      ],
      arabic: [

        {
          label: 'Arabic Title ',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: true,
        },


      ],
      hidden: [


        {
          label: 'Section_id',
          name: 'section_id',
          type: 'hidden',
          value: 25,
          required: true,
        },
      ],
      common: [],
    },
  },

  contact_requests:{

    link: 'dashboard/sections/',
    getRecordLink: 'dashboard/elements/',
    postEditLink: 'dashboard/elements/update/',
    deleteLink: 'dashboard/elements',
    postAddLink: 'dashboard/elements',
    backLink: '/content-manager/list/contact_requests/',
    routerList: '/content-manager/list/contact_requests/',
    hasBackLink: true,
    title: 'Slides',
    edit_title: 'Edit Slide',
    delete_title: 'Delete Slide',
    add_title: 'Add Slide',
    hasCommon: false,
    hasArabic: true,
    hasHidden: true,
    hasAddButton: true,
    hasCategoryAdd:true,
    hasGroupButtons: false,
    hasExportButton: false,
    columns: ['title', 'title_ar', 'editPage'],
    titles: ['Title', 'Arabiv title', 'editPage'],
    edit_form: {
      //Edit of organizational_team
      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title ',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },

      ],
      arabic: [
        //Edit of Venues

        {
          label: 'Arabic Title ',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: true,
        },


      ],
      hidden: [
        {
          label: 'id',
          name: 'id',
          type: 'hidden',
          value: '',
          required: true,
        },

         {
          label: 'Section_id',
          name: 'section_id',
          type: 'hidden',
          value: 24,
          required: true,
        },
      ],
      common: [],
    },
    add_form: {
      //Edit of organizational_team
      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title ',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },


      ],
      arabic: [

        {
          label: 'Arabic Title ',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: true,
        },


      ],
      hidden: [


        {
          label: 'Section_id',
          name: 'section_id',
          type: 'hidden',
          value: 24,
          required: true,
        },
      ],
      common: [],
    },
  },
  menu_pages:{

    link: 'dashboard/sections/',
    getRecordLink: 'dashboard/elements/',
    postEditLink: 'dashboard/elements/update/',
    deleteLink: 'dashboard/elements',
    postAddLink: 'dashboard/elements',
    backLink: '/content-manager/list/menu_pages/',
    routerList: '/content-manager/list/menu_pages/',
    hasBackLink: true,
    title: 'Slides',
    edit_title: 'Edit Slide',
    delete_title: 'Delete Slide',
    add_title: 'Add Slide',
    hasCommon: false,
    hasArabic: true,
    hasHidden: true,
    hasAddButton: false,
    hasCategoryAdd:false,
    hasGroupButtons: false,
    hasExportButton: false,
    columns: ['title', 'title_ar', 'edit'],
    titles: ['Title', 'Arabic title', 'editPage'],
    edit_form: {
      //Edit of organizational_team
      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title ',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Subtitle ',
          name: 'subtitle',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Media',
          name: 'media',
          type: 'file',
          value: '',
          required: true,
        },
        {
          label: 'Media Title',
          name: 'media_title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Use Different Media for Arabic Version.',
          name: 'is_media_different',
          type: 'radio',
          value: '',
          required: false,
          related_to:['media','media_ar'],
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },
      ],
      arabic: [
        //Edit of Venues
        {
          label: 'Arabic Title ',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Arabic Subtitle ',
          name: 'subtitle_ar',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Media',
          name: 'media_ar',
          type: 'file',
          value: '',
          required: false,
        },
        {
          label: 'Arabic Media Title',
          name: 'media_title_ar',
          type: 'text',
          value: '',
          required: true,
        },


      ],
      hidden: [
        {
          label: 'id',
          name: 'id',
          type: 'hidden',
          value: '',
          required: true,
        },

        {
          label: 'Section_id',
          name: 'section_id',
          type: 'hidden',
          value: 39,
          required: true,
        },
      ],
      common: [],
    },
    add_form: {
      //Edit of organizational_team
      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title ',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Subtitle ',
          name: 'subtitle',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Media',
          name: 'media',
          type: 'file',
          value: '',
          required: true,
        },
        {
          label: 'Media Title',
          name: 'media_title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Use Different Media for Arabic Version.',
          name: 'is_media_different',
          type: 'radio',
          value: 0,
          required: false,
          related_to:['media','media_ar'],
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },


      ],
      arabic: [

        {
          label: 'Arabic Title ',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Arabic Subtitle ',
          name: 'subtitle_ar',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Media',
          name: 'media_ar',
          type: 'file',
          value: '',
          required: false,
        },
        {
          label: 'Arabic Media Title',
          name: 'media_title_ar',
          type: 'text',
          value: '',
          required: false,
        },


      ],
      hidden: [


        {
          label: 'Section_id',
          name: 'section_id',
          type: 'hidden',
          value: 40,
          required: true,
        },
      ],
      common: [],
    },
  },
  setting: {
    //faq
    link: 'setting',
    link_group: 'setting/group',
    getRecordLink: 'dashboard/',
    postEditLink: 'dashboard/',
    deleteLink: '',
    postAddLink: '',
    routerList: '/content-manager/setting',
    title: 'Setting',
    backLink: '/content-manager/setting',
    hasBackLink: false,
    edit_title: 'Edit Setting',
    delete_title: 'Delete setting',
    add_title: 'Add setting',
    hasArabic: false,
    hasCommon: false,
    hasHidden: false,
    hasAddButton: false,
    hasImageDimensions:false,
    hasGroupButtons: false,
    hasExportButton: false, //to add/hide csv export
    sections: [
      { key: 'contact_info', title: 'Contact Info' },
      { key: 'social_media', title: 'Social Media' },
      { key: 'og', title: 'Og' },
      { key: 'landscape', title: 'Landscape' },
      { key: 'logo', title: 'Logo' },
      { key: 'fav_icon', title: 'Fav Icon' },
      {key:'website_title', title:'Website title'},
      { key: 'advertising_codes', title: 'Advertising codes' },
      { key: 'riverwards', title: 'riverwards' },
      { key: 'seo', title: 'SEO' },

    ],
    edit_form: [
      //faq

      {
        label: 'Phone',
        name: 'phone',
        type: 'text',
        value: '',
        required: true,
      },
      {
        label: 'email',
        name: 'email',
        type: 'text',
        value: '',
        required: false,
      },
      {
        label: 'facebook',
        name: 'facebook',
        type: 'text',
        value: '',
        required: false,
      },
      {
        label: 'linkedin',
        name: 'linkedin',
        type: 'text',
        value: '',
        required: false,
      },
      {
        label: 'youtube',
        name: 'youtube',
        type: 'text',
        value: '',
        required: false,
      },
      {
        label: 'whatsapp',
        name: 'whatsapp',
        type: 'text',
        value: '',
        required: false,
      },
      {
        label: 'tiktok',
        name: 'tiktok',
        type: 'text',
        value: '',
        required: false,
      },
      {
        label: 'vimeo',
        name: 'vimeo',
        type: 'text',
        value: '',
        required: false,
      },
      {
        label: 'reddit',
        name: 'reddit',
        type: 'text',
        value: '',
        required: false,
      },
      {
        label: 'logo_silver',
        name: 'logo_silver',
        type: 'file',
        value: '',
        required: false,
      },
      {
        label: 'logo_white',
        name: 'logo_white',
        type: 'file',
        value: '',
        required: false,
      },
      {
        label: 'fav_icon',
        name: 'fav_icon',
        type: 'file',
        value: '',
        required: false,
      },
      {
        label: 'website_title',
        name: '',
        type: 'text',
        value: '',
        required: false,
      },
      {
        label: 'address_title',
        name: 'address_title',
        type: 'text',
        value: '',
        required: false,
      },
      {
        label: 'address',
        name: 'address',
        type: 'textarea',
        value: '',
        required: false,
      },
      {
        label: 'address_link',
        name: 'address_link',
        type: 'text',
        value: '',
        required: false,
      },

      {
        label: 'Media',
        name: 'media',
        type: 'file',
        value: '',
        required: true,
      },

      {
        label: 'Media title',
        name: 'media_title',
        type: 'text',
        value: '',
        required: true,
      },
    ],
  },
  media_categories: {
    //faq
    link: 'dashboard/media_categories',
    getRecordLink: 'dashboard/media_categories/',
    postEditLink: 'dashboard/media_categories/update/',
    deleteLink: 'dashboard/media_categories',
    postAddLink: 'dashboard/media_categories',
    routerList: '/content-manager/media_categories',
    title: 'Media Categories',
    backLink: '/content-manager/media_categories',
    hasBackLink: true,
    edit_title: 'Edit Category',
    delete_title: 'Delete Category',
    add_title: 'Add Category',
    hasArabic: true,
    hasCommon: false,
    hasHidden: false,
    hasAddButton: true,
    hasCategoryAdd:false,
    hasGroupButtons: false,
    hasDateSearch: false,
    hasExportButton: false,
    hasExportItem:false,
    columns: ['title', 'title_ar','manage_media','editPage'],
    titles: ['Title', 'Arabic Title','Category Articles', 'Actions'],
    edit_form: {

      english: [

        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },
      ],
      arabic: [

        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: false,
        },
      ],
      hidden: [

      ],
      common: [],
    }, //end of edit faq
    add_form: {
      // add faq
      english: [
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },

      ],
      arabic: [
        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: false,
        },

      ],
      hidden: [

      ],
      common: [

      ],
    },
  },
  media: {
    link: 'dashboard/media_categories/',
    getRecordLink: 'dashboard/medias/',
    postEditLink: 'dashboard/medias/update/',
    deleteLink: 'dashboard/medias',
    postAddLink: 'dashboard/medias',
    routerList: '/content-manager/list/media/',
    title: 'Media',
    backLink: '/content-manager/list/media/',
    hasBackLink: true,
    edit_title: 'Edit Media',
    delete_title: 'Delete Media',
    add_title: 'Add Media',
    hasArabic: true,
    hasCommon: false,
    hasHidden: true,
    hasAddButton: true,
    hasCategoryAdd:true,
    hasGroupButtons: false,
    hasDateSearch: false,
    hasExportButton: false,
    hasExportItem:false,
    columns: ['title', 'title_ar','cover_image','gallery','editPage'],
    titles: ['Title', 'Arabic Title','Cover Image','gallery','Actions'],
    edit_form: {

      english: [

        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Description',
          name: 'description',
          type: 'textarea',
          value: '',
          required: false,
        },
        {
          label: 'Location',
          name: 'location',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Cover Image',
          name: 'cover_image',
          type: 'file',
          value: '',
          required: true,
        },
        {
          label: 'Image Title',
          name: 'image_title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Use Different media for Arabic Version.',
          name: 'is_image_different',
          type: 'radio',
          value: '',
          required: false,
          related_to:['cover_image','cover_image_ar'],
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },
        {
          label: 'Media gallery Type',
          name: 'media_gallery_type',
          type: 'radio',
          value: 'image',
          required: false,
          options: [
            { key: 'image', label: 'image' },
            { key: 'video', label: 'video' },
          ],
        },
        {
          label: 'Brochure',
          name: 'brochure',
          type: 'doc',
          value: '',
          required: false,
        },
        {
          label: 'Use Different Brochure for Arabic Version.',
          name: 'is_brochure_different',
          type: 'radio',
          value: '',
          required: false,
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },
        {
          label: 'Published At',
          name: 'published_at',
          type: 'date',
          value: '',
          required: true,
        },
        {
          label: 'Featured',
          name: 'is_featured',
          type: 'radio',
          value: '',
          required: false,
          options: [
            { key: 0, label: 'No' },
            { key: 1, label: 'Yes' },
          ],
        },
        {
          label: 'Project',
          name: 'project',
          type: 'radio',
          value: '',
          required: false,
          options: [

            { key: 'baymount', label: 'baymount' },
            { key: 'cali', label: 'cali' },
            { key: 'general', label: 'general' },
          ],
        }
      ],
      arabic: [

        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: false,
        },
        {
          label: 'Arabic Description',
          name: 'description_ar',
          type: 'textarea',
          value: '',
          required: false,
        },
        {
          label: 'Arabic Location',
          name: 'location_ar',
          type: 'text',
          value: '',
          required: false,
        },
        {
          label: 'Cover Image',
          name: 'cover_image_ar',
          type: 'file',
          value: '',
          required: false,
        },
        {
          label: 'Arabic Image Title',
          name: 'image_title_ar',
          type: 'text',
          value: '',
          required: false,
        },
        {
          label: 'Arabic Brochure',
          name: 'brochure_ar',
          type: 'doc',
          value: '',
          required: false,
        },
      ],
      hidden: [
        {
          label: 'media_category_id',
          name: 'media_category_id',
          type: 'number',
          value: '',
          required: true,
        },
      ],
      common: [],
    }, //end of edit faq
    add_form: {

      english: [

        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Description',
          name: 'description',
          type: 'textarea',
          value: '',
          required: false,
        },
        {
          label: 'Location',
          name: 'location',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Cover Image',
          name: 'cover_image',
          type: 'file',
          value: '',
          required: true,
        },
        {
          label: 'Image Title',
          name: 'image_title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Use Different media for Arabic Version.',
          name: 'is_image_different',
          type: 'radio',
          value: 0,
          required: false,
          related_to:['cover_image','cover_image_ar'],
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },
        {
          label: 'Media gallery Type:',
          name: 'media_gallery_type',
          type: 'radio',
          value: 'image',
          required: false,
          options: [
            {key: 'image', label: 'image'},
            {key: 'video', label: 'video'},
          ],
        },
        {
          label: 'Brochure',
          name: 'brochure',
          type: 'doc',
          value: '',
          required: false,
        },
        {
          label: 'Use Different Brochure for Arabic Version.',
          name: 'is_brochure_different',
          type: 'radio',
          value: 0,
          required: false,
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },
        {
          label: 'Published At',
          name: 'published_at',
          type: 'date',
          value: '',
          required: true,
        },
        {
          label: 'Featured',
          name: 'is_featured',
          type: 'radio',
          value: 0,
          required: false,
          options: [
            { key: 0, label: 'No' },
            { key: 1, label: 'Yes' },
          ],
        },
        {
          label: 'Project',
          name: 'project',
          type: 'radio',
          value: 'general',
          required: false,
          options: [

            { key: 'baymount', label: 'baymount' },
            { key: 'cali', label: 'cali' },
            { key: 'general', label: 'general' },
          ],
        }
      ],
      arabic: [

        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: false,
        },
        {
          label: 'Arabic Description',
          name: 'description_ar',
          type: 'textarea',
          value: '',
          required: false,
        },
        {
          label: 'Arabic Location',
          name: 'location_ar',
          type: 'text',
          value: '',
          required: false,
        },
        {
          label: 'Cover Image',
          name: 'cover_image_ar',
          type: 'file',
          value: '',
          required: false,
        },
        {
          label: 'Arabic Image Title',
          name: 'image_title_ar',
          type: 'text',
          value: '',
          required: false,
        },
        {
          label: 'Arabic Brochure',
          name: 'brochure_ar',
          type: 'doc',
          value: '',
          required: false,
        },
      ],
      hidden: [
        {
          label: 'media_category_id',
          name: 'media_category_id',
          type: 'number',
          value: '',
          required: true,
        },
      ],
      common: [],
    },
  },
  media_gallery:{
    link: 'dashboard/medias/',
    getRecordLink: 'dashboard/media_gallery/',
    postEditLink: 'dashboard/media_gallery/update/',
    deleteLink: 'dashboard/media_gallery',
    postAddLink: 'dashboard/media_gallery',
    routerList: '/content-manager/list/media_gallery/',
    title: 'Media Gallery',
    backLink: '/content-manager/list/media_gallery/',
    hasBackLink: true,
    edit_title: 'Edit Gallery',
    delete_title: 'Delete Gallery',
    add_title: 'Add Gallery',
    hasArabic: true,
    hasCommon: false,
    hasHidden: true,
    hasAddButton: true,
    hasCategoryAdd:true,
    hasGroupButtons: false,
    hasDateSearch: false,
    hasExportButton: false,
    hasExportItem:false,
    columns: ['image','editPage'],
    titles: ['Image','Actions'],
    edit_form: {

      english: [

        {
          label: 'Image',
          name: 'image',
          type: 'file',
          value: '',
          required: true,
        },
        {
          label: 'Image Title',
          name: 'image_title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Use Different media for Arabic Version.',
          name: 'is_image_different',
          type: 'radio',
          value: '',
          related_to:['image','image_ar'],
          required: false,
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },
        {
          label: 'Videl Link',
          name: 'url',
          type: 'text',
          value: '',
          required: false,
        },

      ],
      arabic: [


        {
          label: 'Image',
          name: 'image_ar',
          type: 'file',
          value: '',
          required: false,
        },
        {
          label: 'Image Title',
          name: 'image_title_ar',
          type: 'text',
          value: '',
          required: false,
        },


      ],
      hidden: [
        {
          label: 'media_id',
          name: 'media_id',
          type: 'number',
          value: '',
          required: true,
        },
      ],
      common: [],
    }, //end of edit faq
    add_form:{

      english: [

        {
          label: 'Image',
          name: 'image',
          type: 'file',
          value: '',
          required: true,
        },
        {
          label: 'Image Title',
          name: 'image_title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Use Different media for Arabic Version.',
          name: 'is_image_different',
          type: 'radio',
          value: 0,
          required: false,
          related_to:['image','image_ar'],
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },
        {
          label: 'Videl Link',
          name: 'url',
          type: 'text',
          value: '',
          required: false,
        },

      ],
      arabic: [


        {
          label: 'Image',
          name: 'image_ar',
          type: 'file',
          value: '',
          required: true,
        },
        {
          label: 'Image Title',
          name: 'image_title_ar',
          type: 'text',
          value: '',
          required: true,
        },


      ],
      hidden: [
        {
          label: 'media_id',
          name: 'media_id',
          type: 'number',
          value: '',
          required: true,
        },
      ],
      common: [],
    },
  },
  vacancies: {
    //faq
    link: 'dashboard/vacancies',
    searchlink: 'dashboard/vacancies/search',
    getRecordLink: 'dashboard/vacancies/',
    postEditLink: 'dashboard/vacancies/update/',
    postAddLink: 'dashboard/vacancies ',
    routerList: '/content-manager/vacancies',
    title: 'Vacancies',
    backLink: '/content-manager/vacancies',
    hasBackLink: true,
    edit_title: 'Edit Vacancy',
    delete_title: 'Delete',
    add_title: 'Add Vacancy',
    hasArabic: true,
    hasCommon: false,
    hasHidden: false,
    hasAddButton: true,
    hasGroupButtons: false,
    hasDateSearch: false,
    hasExportButton: false,
    hasExportItem:false, //to add/hide csv export
    exportOptions: {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: false,
      showTitle: false,
      useBom: true,
    },
    columns: [
      'title',
      'description',
      'type',
      'location',
      'published_at',
      'is_active',
      'edit',
    ],
    titles: [
      'title',
      'description',
      'type',
      'location',
      'published at',
      'stauts',
      'Action',
    ],
    edit_form: {
      //Edit of organizational_team
      english: [

        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },

        {
          label: 'Description',
          name: 'description',
          type: 'textarea',
          value: '',
          required: true,
        },
        {
          label: 'Localtion',
          name: 'location',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Type',
          name: 'type',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Published At',
          name: 'published_at',
          type: 'date',
          value: '',
          required: true,
        },
        {
          label: 'Is Job Active ?.',
          name: 'is_active',
          type: 'radio',
          value: '',
          required: false,
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },
      ],
      arabic: [
        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: true,
        },

        {
          label: 'Arabic Description',
          name: 'description_ar',
          type: 'textarea',
          value: '',
          required: true,
        },
        {
          label: 'Arabic Localtion',
          name: 'location_ar',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Arabic Type',
          name: 'type_ar',
          type: 'text',
          value: '',
          required: true,
        },
      ],
      hidden: [

      ],
      common: [],
    },
    add_form: {
      //Edit of organizational_team
      english: [

        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },

        {
          label: 'Description',
          name: 'description',
          type: 'textarea',
          value: '',
          required: true,
        },
        {
          label: 'Localtion',
          name: 'location',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Type',
          name: 'type',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Published At',
          name: 'published_at',
          type: 'date',
          value: '',
          required: true,
        },
        {
          label: 'Is Job Active ?.',
          name: 'is_active',
          type: 'radio',
          value: 0,
          required: false,
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },
      ],
      arabic: [
        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: true,
        },

        {
          label: 'Arabic Description',
          name: 'description_ar',
          type: 'textarea',
          value: '',
          required: true,
        },
        {
          label: 'Arabic Localtion',
          name: 'location_ar',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Arabic Type',
          name: 'type_ar',
          type: 'text',
          value: '',
          required: true,
        },
      ],
      hidden: [

      ],
      common: [],
    },
  },

  about_sister_company:{

    link: 'dashboard/sections/',
    getRecordLink: 'dashboard/elements/',
    postEditLink: 'dashboard/elements/update/',
    deleteLink: 'dashboard/elements',
    postAddLink: 'dashboard/elements',
    backLink: '/content-manager/list/about_sister_company/',
    routerList: '/content-manager/list/about_sister_company/',
    hasBackLink: true,
    title: 'Slides',
    edit_title: 'Edit Slide',
    delete_title: 'Delete Slide',
    add_title: 'Add Slide',
    hasCommon: false,
    hasArabic: true,
    hasHidden: true,
    hasAddButton: false,
    hasGroupButtons: false,
    hasExportButton: false,
    hasCategoryAdd:false,
    columns: ['title', 'description', 'edit'],
    titles: ['Title', 'Description', 'editPage'],
    edit_form: {
      //Edit of organizational_team
      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title ',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Media',
          name: 'media',
          type: 'file',
          value: '',
          required:true,
        },
         {
          label: 'Media Title',
          name: 'media_title',
          type: 'text',
          value: '',
          required: true,
        },
      ],
      arabic: [
        //Edit of Venues

        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: false,
        },
        {
          label: 'Media',
          name: 'media_ar',
          type: 'file',
          value: '',
          required:false,
        },
         {
          label: 'Arabic Media Title',
          name: 'media_title_ar',
          type: 'text',
          value: '',
          required: false,
        },


      ],
      hidden: [
        {
          label: 'id',
          name: 'id',
          type: 'hidden',
          value: '',
          required: true,
        },

        {
          label: 'Section_id',
          name: 'section_id',
          type: 'hidden',
          value: 35,
          required: true,
        },
      ],
      common: [],
    },
    add_form: {
      //Edit of organizational_team
      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title ',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Media',
          name: 'media',
          type: 'file',
          value: '',
          required:true,
        },
         {
          label: 'Media Title',
          name: 'media_title',
          type: 'text',
          value: '',
          required: true,
        },
      ],
      arabic: [
        //Edit of Venues

        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: false,
        },
        {
          label: 'Media',
          name: 'media_ar',
          type: 'file',
          value: '',
          required:false,
        },
         {
          label: 'Arabic Media Title',
          name: 'media_title_ar',
          type: 'text',
          value: '',
          required: false,
        },


      ],
      hidden: [


        {
          label: 'Section_id',
          name: 'section_id',
          type: 'hidden',
          value: 35,
          required: true,
        },
      ],
      common: [],
    },
  },
  home_media:{

    link: 'dashboard/medias/select',
    getRecordLink: 'dashboard/medias/select/',
    postEditLink: 'dashboard/elements/update/',
    deleteLink: 'dashboard/medias/select',
    postAddLink: 'dashboard/medias/select/',
    backLink: '/content-manager/list/home_media/',
    routerList: '/content-manager/list/home_media/',
    hasBackLink: true,
    title: 'Slides',
    edit_title: 'Edit Slide',
    delete_title: 'Delete Slide',
    add_title: 'Add Slide',
    hasCommon: false,
    hasArabic: true,
    hasHidden: true,
    hasAddButton: false,
    hasGroupButtons: false,
    hasExportButton: false,
    hasCategoryAdd:false,
    columns: ['title', 'cover_image','is_featured'],
    titles: ['Title', 'Cover Image', 'featured'],

  },
  email_notifications_applicants:{
    link: 'dashboard/email_notifications/list/applicants',
    getRecordLink: 'dashboard/email_notifications/',
    postEditLink: 'dashboard/email_notifications/update/',
    deleteLink: 'dashboard/email_notifications',
    postAddLink: 'dashboard/email_notifications',
    routerList: '/content-manager/email_notifications_applicants',
    title: 'Email Notifications',
    backLink: '/content-manager/email_notifications_applicants',
    hasBackLink: true,
    edit_title: 'Edit Email',
    delete_title: 'Delete',
    add_title: 'Add Email',
    hasArabic: false,
    hasCommon: false,
    hasHidden: false,
    hasAddButton: true,
    hasGroupButtons: false,
    hasDateSearch: false,
    hasExportButton: false,
    hasExportItem:false, //to add/hide csv export
    columns: [
      'email',
      'editPage'
  ],
  titles: [
    'email',

  ],
  edit_form: {
    english:
     [
      {
        label: 'Email',
        name: 'email',
        type: 'text',
        value: '',
        required: true,
      },
      {
        label: 'id',
        name: 'id',
        type: 'hidden',
        value: '',
        required: true,
      },
      {
        label: 'Type',
        name: 'type',
        type: 'hidden',
        value: 'applicants',
        required: true,
      },
    ],
    },
    add_form: {
      english:[
      {
        label: 'Email',
        name: 'email',
        type: 'text',
        value: '',
        required: true,
      },
      {
        label: 'Type',
        name: 'type',
        type: 'hidden',
        value: 'applicants',
        required: true,
      },

    ]
   },
  },
  email_notifications_inquiries:{
    link: 'dashboard/email_notifications/list/inquiries',
    getRecordLink: 'dashboard/email_notifications/',
    postEditLink: 'dashboard/email_notifications/update/',
    deleteLink: 'dashboard/email_notifications',
    postAddLink: 'dashboard/email_notifications',
    routerList: '/content-manager/email_notifications_inquiries',
    title: 'Email Notifications',
    backLink: '/content-manager/email_notifications_inquiries',
    hasBackLink: true,
    edit_title: 'Edit Email',
    delete_title: 'Delete',
    add_title: 'Add Email',
    hasArabic: false,
    hasCommon: false,
    hasHidden: false,
    hasAddButton: true,
    hasGroupButtons: false,
    hasDateSearch: false,
    hasExportButton: false,
    hasExportItem:false, //to add/hide csv export
    columns: [
      'email',
      'editPage'
  ],
  titles: [
    'email',

  ],
  edit_form: {
  english:
   [
    {
      label: 'Email',
      name: 'email',
      type: 'text',
      value: '',
      required: true,
    },
    {
      label: 'id',
      name: 'id',
      type: 'hidden',
      value: '',
      required: true,
    },
    {
      label: 'Type',
      name: 'type',
      type: 'hidden',
      value: 'inquiries',
      required: true,
    },
  ],
  },
  add_form: {
    english:[
    {
      label: 'Email',
      name: 'email',
      type: 'text',
      value: '',
      required: true,
    },
    {
      label: 'Type',
      name: 'type',
      type: 'hidden',
      value: 'inquiries',
      required: true,
    },

  ]
 },
  },
  email_notifications_offers:{
    link: 'dashboard/email_notifications/list/offers',
    getRecordLink: 'dashboard/email_notifications/',
    postEditLink: 'dashboard/email_notifications/update/',
    deleteLink: 'dashboard/email_notifications',
    postAddLink: 'dashboard/email_notifications',
    routerList: '/content-manager/email_notifications_offers',
    title: 'Email Notifications',
    backLink: '/content-manager/email_notifications_offers',
    hasBackLink: true,
    edit_title: 'Edit Email',
    delete_title: 'Delete',
    add_title: 'Add Email',
    hasArabic: false,
    hasCommon: false,
    hasHidden: false,
    hasAddButton: true,
    hasGroupButtons: false,
    hasDateSearch: false,
    hasExportButton: false,
    hasExportItem:false, //to add/hide csv export
    columns: [
      'email',
      'editPage'
  ],
  titles: [
    'email',

  ],
  edit_form: {
  english:
   [
    {
      label: 'Email',
      name: 'email',
      type: 'text',
      value: '',
      required: true,
    },
    {
      label: 'id',
      name: 'id',
      type: 'hidden',
      value: '',
      required: true,
    },
    {
      label: 'Type',
      name: 'type',
      type: 'hidden',
      value: 'offers',
      required: true,
    },
  ],
  },
  add_form: {
    english:[
    {
      label: 'Email',
      name: 'email',
      type: 'text',
      value: '',
      required: true,
    },
    {
      label: 'Type',
      name: 'type',
      type: 'hidden',
      value: 'offers',
      required: true,
    },

  ]
 },
  },
  email_notifications_axa_offers:{
    link: 'dashboard/email_notifications/list/axa_offers',
    getRecordLink: 'dashboard/email_notifications/',
    postEditLink: 'dashboard/email_notifications/update/',
    deleteLink: 'dashboard/email_notifications',
    postAddLink: 'dashboard/email_notifications',
    routerList: '/content-manager/email_notifications_axa_offers',
    title: 'Email Notifications',
    backLink: '/content-manager/email_notifications_axa_offers',
    hasBackLink: true,
    edit_title: 'Edit Email',
    delete_title: 'Delete',
    add_title: 'Add Email',
    hasArabic: false,
    hasCommon: false,
    hasHidden: false,
    hasAddButton: true,
    hasGroupButtons: false,
    hasDateSearch: false,
    hasExportButton: false,
    hasExportItem:false, //to add/hide csv export
    columns: [
      'email',
      'editPage'
  ],
  titles: [
    'email',

  ],
  edit_form: {
    english:
     [
      {
        label: 'Email',
        name: 'email',
        type: 'text',
        value: '',
        required: true,
      },
      {
        label: 'id',
        name: 'id',
        type: 'hidden',
        value: '',
        required: true,
      },
      {
        label: 'Type',
        name: 'type',
        type: 'hidden',
        value: 'axa_offers',
        required: true,
      },
    ],
    },
    add_form: {
      english:[
      {
        label: 'Email',
        name: 'email',
        type: 'text',
        value: '',
        required: true,
      },
      {
        label: 'Type',
        name: 'type',
        type: 'hidden',
        value: 'axa_offers',
        required: true,
      },

    ]
   },
  },
  cali_notifications_inquiries:{
    link: 'dashboard/email_notifications/list/cali_inquiries',
    getRecordLink: 'dashboard/email_notifications/',
    postEditLink: 'dashboard/email_notifications/update/',
    deleteLink: 'dashboard/email_notifications',
    postAddLink: 'dashboard/email_notifications',
    routerList: '/content-manager/cali_notifications_inquiries',
    title: 'Email Notifications',
    backLink: '/content-manager/cali_notifications_inquiries',
    hasBackLink: true,
    edit_title: 'Edit Email',
    delete_title: 'Delete',
    add_title: 'Add Email',
    hasArabic: false,
    hasCommon: false,
    hasHidden: false,
    hasAddButton: true,
    hasGroupButtons: false,
    hasDateSearch: false,
    hasExportButton: false,
    hasExportItem:false, //to add/hide csv export
    columns: [
      'email',
      'editPage'
  ],
  titles: [
    'email',

  ],
  edit_form: {
  english:
   [
    {
      label: 'Email',
      name: 'email',
      type: 'text',
      value: '',
      required: true,
    },
    {
      label: 'id',
      name: 'id',
      type: 'hidden',
      value: '',
      required: true,
    },
    {
      label: 'Type',
      name: 'type',
      type: 'hidden',
      value: 'cali_inquiries',
      required: true,
    },
  ],
  },
  add_form: {
    english:[
    {
      label: 'Email',
      name: 'email',
      type: 'text',
      value: '',
      required: true,
    },
    {
      label: 'Type',
      name: 'type',
      type: 'hidden',
      value: 'cali_inquiries',
      required: true,
    },

  ]
 },
  },
  baymount_notifications_inquiries:{
    link: 'dashboard/email_notifications/list/baymount_inquiries',
    getRecordLink: 'dashboard/email_notifications/',
    postEditLink: 'dashboard/email_notifications/update/',
    deleteLink: 'dashboard/email_notifications',
    postAddLink: 'dashboard/email_notifications',
    routerList: '/content-manager/baymount_notifications_inquiries',
    title: 'Email Notifications',
    backLink: '/content-manager/baymount_notifications_inquiries',
    hasBackLink: true,
    edit_title: 'Edit Email',
    delete_title: 'Delete',
    add_title: 'Add Email',
    hasArabic: false,
    hasCommon: false,
    hasHidden: false,
    hasAddButton: true,
    hasGroupButtons: false,
    hasDateSearch: false,
    hasExportButton: false,
    hasExportItem:false, //to add/hide csv export
    columns: [
      'email',
      'editPage'
  ],
  titles: [
    'email',

  ],
  edit_form: {
  english:
   [
    {
      label: 'Email',
      name: 'email',
      type: 'text',
      value: '',
      required: true,
    },
    {
      label: 'id',
      name: 'id',
      type: 'hidden',
      value: '',
      required: true,
    },
    {
      label: 'Type',
      name: 'type',
      type: 'hidden',
      value: 'baymount_inquiries',
      required: true,
    },
  ],
  },
  add_form: {
    english:[
    {
      label: 'Email',
      name: 'email',
      type: 'text',
      value: '',
      required: true,
    },
    {
      label: 'Type',
      name: 'type',
      type: 'hidden',
      value: 'baymount_inquiries',
      required: true,
    },

  ]
 },
  },
  cali_map:{

    link: 'dashboard/sections/',
    getRecordLink: 'dashboard/elements/',
    postEditLink: 'dashboard/elements/update/',
    deleteLink: 'dashboard/elements',
    postAddLink: 'dashboard/elements',
    backLink: '/content-manager/list/cali_map/',
    routerList: '/content-manager/list/cali_map/',
    hasBackLink: true,
    title: 'Slides',
    edit_title: 'Edit Slide',
    delete_title: 'Delete Slide',
    add_title: 'Add Slide',
    hasCommon: false,
    hasArabic: true,
    hasHidden: true,
    hasAddButton: false,
    hasCategoryAdd:false,
    hasGroupButtons: false,
    hasExportButton: false,
    columns: ['title','subtitle', 'title_ar', 'edit'],
    titles: ['Title', 'subtitle','Arabic Title', 'editPage'],
    edit_form: {

      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },

        {
          label: 'Subtitle',
          name: 'subtitle',
          type: 'text',
          value: '',
          required: true,
        },


      ],
      arabic: [
        //Edit of Venues
        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: false,
        },

        {
          label: 'Arabic Subtitle',
          name: 'subtitle_ar',
          type: 'text',
          value: '',
          required: false,
        },

      ],
      hidden: [
        {
          label: 'id',
          name: 'id',
          type: 'hidden',
          value: '',
          required: true,
        },

        {
          label: 'section_id',
          name: 'section_id',
          type: 'hidden',
          value: 46,
          required: true,
        },
      ],
      common: [],
    },
    add_form: {
      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Subtitle',
          name: 'subtitle',
          type: 'text',
          value: '',
          required: true,
        },


      ],
      arabic: [
        //Edit of Venues
        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: false,
        },

  {
          label: 'Arabic Subtitle',
          name: 'subtitle_ar',
          type: 'text',
          value: '',
          required: false,
        },

      ],
      hidden: [


        {
          label: 'section_id',
          name: 'section_id',
          type: 'hidden',
          value: 46,
          required: true,
        },
      ],
      common: [],
    },
  },
  cali_partners_details:{

    link: 'dashboard/sections/',
    getRecordLink: 'dashboard/elements/',
    postEditLink: 'dashboard/elements/update/',
    deleteLink: 'dashboard/elements',
    postAddLink: 'dashboard/elements',
    backLink: '/content-manager/list/cali_partners_details/',
    routerList: '/content-manager/list/cali_partners_details/',
    hasBackLink: true,
    title: 'Slides',
    edit_title: 'Edit Slide',
    delete_title: 'Delete Slide',
    add_title: 'Add Slide',
    hasCommon: false,
    hasArabic: true,
    hasHidden: true,
    hasAddButton: true,
    hasCategoryAdd:true,
    hasGroupButtons: false,
    hasExportButton: false,
    columns: ['title','subtitle', 'media', 'editPage'],
    titles: ['Title', 'subtitle','media', 'editPage'],
    edit_form: {

      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },

        {
          label: 'Subtitle',
          name: 'subtitle',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Description',
          name: 'description',
          type: 'textarea',
          value: '',
          required: true,
        },
        {
          label: 'Icon',
          name: 'icon',
          type: 'file',
          value: '',
          required: true,
        },
 {
          label: 'Use Different Icon for Arabic Version.',
          name: 'is_icon_different',
          type: 'radio',
          value: '',
          related_to:['icon','icon_ar'],
          required: false,
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },
        {
          label: 'Media',
          name: 'media',
          type: 'file',
          value: '',
          required: true,
        },
 {
          label: 'Use Different Media for Arabic Version.',
          name: 'is_media_different',
          type: 'radio',
          value: '',
          related_to:['media','media_ar'],
          required: false,
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },
        {
          label: 'Link',
          name: 'url',
          type: 'text',
          value: '',
          required: true,
        },
      ],
      arabic: [
        //Edit of Venues
        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: false,
        },

        {
          label: 'Arabic Subtitle',
          name: 'subtitle_ar',
          type: 'text',
          value: '',
          required: false,
        },
        {
          label: 'Arabic Description',
          name: 'description_ar',
          type: 'textarea',
          value: '',
          required: false,
        },
        {
          label: 'Arabic Icon',
          name: 'icon_ar',
          type: 'file',
          value: '',
          required: false,
        },
 {
          label: 'Arabic Media',
          name: 'media_ar',
          type: 'file',
          value: '',
          required: false,
        },
      ],
      hidden: [
        {
          label: 'id',
          name: 'id',
          type: 'hidden',
          value: '',
          required: true,
        },

        {
          label: 'section_id',
          name: 'section_id',
          type: 'hidden',
          value: 47,
          required: true,
        },
      ],
      common: [],
    },
    add_form: {
      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },

        {
          label: 'Subtitle',
          name: 'subtitle',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Description',
          name: 'description',
          type: 'textarea',
          value: '',
          required: true,
        },
        {
          label: 'Icon',
          name: 'icon',
          type: 'file',
          value: '',
          required: false,
        },
 {
          label: 'Use Different icon for Arabic Version.',
          name: 'is_icon_different',
          type: 'radio',
          value: '',
          related_to:['icon','icon_ar'],
          required: false,
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },
        {
          label: 'Media',
          name: 'media',
          type: 'file',
          value: '',
          required: false,
        },
 {
          label: 'Use Different Media for Arabic Version.',
          name: 'is_media_different',
          type: 'radio',
          value: '',
          related_to:['media','media_ar'],
          required: false,
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },
        {
          label: 'Link',
          name: 'url',
          type: 'text',
          value: '',
          required: true,
        },
      ],
      arabic: [
        //Edit of Venues
        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: false,
        },

        {
          label: 'Arabic Subtitle',
          name: 'subtitle_ar',
          type: 'text',
          value: '',
          required: false,
        },
        {
          label: 'Arabic Description',
          name: 'description_ar',
          type: 'textarea',
          value: '',
          required: false,
        },
        {
          label: 'Arabic Icon',
          name: 'icon_ar',
          type: 'file',
          value: '',
          required: false,
        },
 {
          label: 'Arabic Media',
          name: 'media_ar',
          type: 'file',
          value: '',
          required: false,
        },
      ],
      hidden: [


        {
          label: 'section_id',
          name: 'section_id',
          type: 'hidden',
          value: 47,
          required: true,
        },
      ],
      common: [],
    },
  },
  cali_statistics:{

    link: 'dashboard/sections/',
    getRecordLink: 'dashboard/elements/',
    postEditLink: 'dashboard/elements/update/',
    deleteLink: 'dashboard/elements',
    postAddLink: 'dashboard/elements',
    backLink: '/content-manager/list/cali_statistics/',
    routerList: '/content-manager/list/cali_statistics/',
    hasBackLink: true,
    title: 'Slides',
    edit_title: 'Edit Slide',
    delete_title: 'Delete Slide',
    add_title: 'Add Slide',
    hasCommon: false,
    hasArabic: true,
    hasHidden: true,
    hasAddButton: false,
    hasCategoryAdd:false,
    hasGroupButtons: false,
    hasExportButton: false,
    columns: ['title','subtitle', 'title_ar', 'edit'],
    titles: ['Title', 'subtitle','Arabic Title', 'editPage'],
    edit_form: {

      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },

        {
          label: 'Subtitle',
          name: 'subtitle',
          type: 'text',
          value: '',
          required: true,
        },


      ],
      arabic: [
        //Edit of Venues
        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: false,
        },

        {
          label: 'Arabic Subtitle',
          name: 'subtitle_ar',
          type: 'text',
          value: '',
          required: false,
        },

      ],
      hidden: [
        {
          label: 'id',
          name: 'id',
          type: 'hidden',
          value: '',
          required: true,
        },

        {
          label: 'section_id',
          name: 'section_id',
          type: 'hidden',
          value: 49,
          required: true,
        },
      ],
      common: [],
    },
    add_form: {
      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Subtitle',
          name: 'subtitle',
          type: 'text',
          value: '',
          required: true,
        },


      ],
      arabic: [
        //Edit of Venues
        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: false,
        },

  {
          label: 'Arabic Subtitle',
          name: 'subtitle_ar',
          type: 'text',
          value: '',
          required: false,
        },

      ],
      hidden: [


        {
          label: 'section_id',
          name: 'section_id',
          type: 'hidden',
          value: 49,
          required: true,
        },
      ],
      common: [],
    },
  },
  cali_masterplan:{

    link: 'dashboard/sections/',
    getRecordLink: 'dashboard/elements/',
    postEditLink: 'dashboard/elements/update/',
    deleteLink: 'dashboard/elements',
    postAddLink: 'dashboard/elements',
    backLink: '/content-manager/list/cali_masterplan/',
    routerList: '/content-manager/list/cali_masterplan/',
    hasBackLink: true,
    title: 'Slides',
    edit_title: 'Edit Slide',
    delete_title: 'Delete Slide',
    add_title: 'Add Slide',
    hasCommon: false,
    hasArabic: true,
    hasHidden: true,
    hasAddButton: false,
    hasCategoryAdd:false,
    hasGroupButtons: false,
    hasExportButton: false,
    columns: ['title', 'media', 'edit'],
    titles: ['title','media', 'editPage'],
    edit_form: {

      english: [

        {
          label: 'Description',
          name: 'description',
          type: 'textarea',
          value: '',
          required: true,
        },

        {
          label: 'Media',
          name: 'media',
          type: 'file',
          value: '',
          required: true,
        },
        {
          label: 'Use Different Media for Arabic Version.',
          name: 'is_media_different',
          type: 'radio',
          value: '',
          required: false,
          related_to:['media','media_ar'],
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },
        {
          label: 'Icon',
          name: 'icon',
          type: 'file',
          value: '',
          required: true,
        },
         {
          label: 'Use Different Icon for Arabic Version.',
          name: 'is_icon_different',
          type: 'radio',
          value: '',
          required: false,
          related_to:['media','media_ar'],
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },
      ],
      arabic: [
        //Edit of Venues
        {
          label: 'Arabic Description',
          name: 'description_ar',
          type: 'textarea',
          value: '',
          required: true,
        },

        {
          label: 'Arabic Media',
          name: 'media_ar',
          type: 'file',
          value: '',
          required: true,
        },
        {
          label: 'Arabic Icon',
          name: 'icon_ar',
          type: 'file',
          value: '',
          required: false,
        },
      ],
      hidden: [
        {
          label: 'order',
          name: 'order',
          type: 'hidden',
          value: '',
          required: true,
        },
        {
          label: 'id',
          name: 'id',
          type: 'hidden',
          value: '',
          required: true,
        },
        {
          label: 'title',
          name: 'title',
          type: 'hidden',
          value: '',
          required: true,
        },
        {
          label: 'Arabic title',
          name: 'title_ar',
          type: 'hidden',
          value: '',
          required: true,
        },
        {
          label: 'section_id',
          name: 'section_id',
          type: 'hidden',
          value: 48,
          required: true,
        },
      ],
      common: [],
    },
    add_form: {
      english: [

        {
          label: 'Description',
          name: 'description',
          type: 'textarea',
          value: '',
          required: true,
        },

        {
          label: 'Media',
          name: 'media',
          type: 'file',
          value: '',
          required: true,
        },
        {
          label: 'Use Different Media for Arabic Version.',
          name: 'is_media_different',
          type: 'radio',
          value: '',
          required: false,
          related_to:['media','media_ar'],
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },
        {
          label: 'Icon',
          name: 'icon',
          type: 'file',
          value: '',
          required: true,
        },
         {
          label: 'Use Different Icon for Arabic Version.',
          name: 'is_icon_different',
          type: 'radio',
          value: '',
          required: false,
          related_to:['media','media_ar'],
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },
      ],
      arabic: [
        //Edit of Venues
        {
          label: 'Arabic Description',
          name: 'description_ar',
          type: 'textarea',
          value: '',
          required: true,
        },

        {
          label: 'Arabic Media',
          name: 'media_ar',
          type: 'file',
          value: '',
          required: true,
        },
        {
          label: 'Arabic Icon',
          name: 'icon_ar',
          type: 'file',
          value: '',
          required: false,
        },
      ],
      hidden: [
        {
          label: 'id',
          name: 'id',
          type: 'hidden',
          value: '',
          required: true,
        },

        {
          label: 'section_id',
          name: 'section_id',
          type: 'hidden',
          value: 48,
          required: true,
        },
      ],
      common: [],
    },
  },
  cali_partners:{

    link: 'dashboard/sections/',
    getRecordLink: 'dashboard/elements/',
    postEditLink: 'dashboard/elements/update/',
    deleteLink: 'dashboard/elements',
    postAddLink: 'dashboard/elements',
    backLink: '/content-manager/list/cali_partners/',
    routerList: '/content-manager/list/cali_partners/',
    hasBackLink: true,
    title: 'Slides',
    edit_title: 'Edit Slide',
    delete_title: 'Delete Slide',
    add_title: 'Add Slide',
    hasCommon: false,
    hasArabic: true,
    hasHidden: true,
    hasAddButton: true,
    hasCategoryAdd:true,
    hasGroupButtons: false,
    hasExportButton: false,
    columns: ['title', 'title_ar', 'icon', 'editPage'],
    titles: ['Title', 'Arabic Title', 'icon', 'editPage'],
    edit_form: {

      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Logo',
          name: 'icon',
          type: 'file',
          value: '',
          required: true,
        },
 {
          label: 'Use Different Logo for Arabic Version.',
          name: 'is_icon_different',
          type: 'radio',
          value: '',
          related_to:['icon','icon_ar'],
          required: false,
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },
        {
          label: 'Link',
          name: 'url',
          type: 'text',
          value: '',
          required: true,
        },


      ],
      arabic: [
        //Edit of Venues
        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: true,
        },

        {
          label: 'Arabic Logo',
          name: 'icon_ar',
          type: 'file',
          value: '',
          required: false,
        },

      ],
      hidden: [
        {
          label: 'id',
          name: 'id',
          type: 'hidden',
          value: '',
          required: true,
        },

        {
          label: 'section_id',
          name: 'section_id',
          type: 'hidden',
          value: 50,
          required: true,
        },
      ],
      common: [],
    },
    add_form: {
      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Logo',
          name: 'icon',
          type: 'file',
          value: '',
          required: true,
        },
 {
          label: 'Use Different Logo for Arabic Version.',
          name: 'is_icon_different',
          type: 'radio',
          value: '',
          related_to:['icon','icon_ar'],
          required: false,
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },
        {
          label: 'Link',
          name: 'url',
          type: 'text',
          value: '',
          required: true,
        },


      ],
      arabic: [
        //Edit of Venues
        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: false,
        },

        {
          label: 'Arabic Logo',
          name: 'icon_ar',
          type: 'file',
          value: '',
          required: false,
        },

      ],
      hidden: [


        {
          label: 'section_id',
          name: 'section_id',
          type: 'hidden',
          value: 50,
          required: true,
        },
      ],
      common: [],
    },
  },
  cali_inquiry_unit:{

    link: 'dashboard/sections/',
    getRecordLink: 'dashboard/elements/',
    postEditLink: 'dashboard/elements/update/',
    deleteLink: 'dashboard/elements',
    postAddLink: 'dashboard/elements',
    backLink: '/content-manager/list/cali_inquiry_unit/',
    routerList: '/content-manager/list/cali_inquiry_unit/',
    hasBackLink: true,
    title: 'Slides',
    edit_title: 'Edit Slide',
    delete_title: 'Delete Slide',
    add_title: 'Add Slide',
    hasCommon: false,
    hasArabic: true,
    hasHidden: true,
    hasAddButton: true,
    hasCategoryAdd:true,
    hasGroupButtons: false,
    hasExportButton: false,
    columns: ['title', 'title_ar', 'editPage'],
    titles: ['Title', 'Arabic Title', 'editPage'],
    edit_form: {

      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },




      ],
      arabic: [
        //Edit of Venues
        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: false,
        },



      ],
      hidden: [
        {
          label: 'id',
          name: 'id',
          type: 'hidden',
          value: '',
          required: true,
        },

        {
          label: 'section_id',
          name: 'section_id',
          type: 'hidden',
          value: 54,
          required: true,
        },
      ],
      common: [],
    },
    add_form: {
      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },



      ],
      arabic: [
        //Edit of Venues
        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: false,
        },


      ],
      hidden: [


        {
          label: 'section_id',
          name: 'section_id',
          type: 'hidden',
          value:54,
          required: true,
        },
      ],
      common: [],
    },
  },
  cali_inquiry_time:{

    link: 'dashboard/sections/',
    getRecordLink: 'dashboard/elements/',
    postEditLink: 'dashboard/elements/update/',
    deleteLink: 'dashboard/elements',
    postAddLink: 'dashboard/elements',
    backLink: '/content-manager/list/cali_inquiry_unit/',
    routerList: '/content-manager/list/cali_inquiry_unit/',
    hasBackLink: true,
    title: 'Slides',
    edit_title: 'Edit Slide',
    delete_title: 'Delete Slide',
    add_title: 'Add Slide',
    hasCommon: false,
    hasArabic: true,
    hasHidden: true,
    hasAddButton: true,
    hasCategoryAdd:false,
    hasGroupButtons: false,
    hasExportButton: false,
    columns: ['title', 'title_ar', 'editPage'],
    titles: ['Title', 'Arabic Title', 'editPage'],
    edit_form: {

      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },




      ],
      arabic: [
        //Edit of Venues
        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: false,
        },



      ],
      hidden: [
        {
          label: 'id',
          name: 'id',
          type: 'hidden',
          value: '',
          required: true,
        },

        {
          label: 'section_id',
          name: 'section_id',
          type: 'hidden',
          value: 55,
          required: true,
        },
      ],
      common: [],
    },
    add_form: {
      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },



      ],
      arabic: [
        //Edit of Venues
        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: false,
        },


      ],
      hidden: [


        {
          label: 'section_id',
          name: 'section_id',
          type: 'hidden',
          value:55,
          required: true,
        },
      ],
      common: [],
    },
  },
  cali_units: {
    link: 'dashboard/cali_units',
    getRecordLink: 'dashboard/cali_units/',
    postEditLink: 'dashboard/cali_units/update/',
    deleteLink: 'dashboard/cali_units',
    postAddLink: 'dashboard/cali_units',
    routerList: '/content-manager/cali_units',
    title: 'Cali Units',
    backLink: '/content-manager/cali_units',
    hasBackLink: true,
    edit_title: 'Edit unit',
    delete_title: 'Delete unit',
    add_title: 'Add unit',
    hasArabic: true,
    hasCommon: false,
    hasHidden: true,
    hasAddButton: false,
    hasCategoryAdd:false,
    hasGroupButtons: false,
    hasDateSearch: false,
    hasExportButton: false,
    hasExportItem:false,
    columns: ['order','title', 'title_ar','manage_cali_units','edit'],
    titles: ['Order' , 'Title', 'Arabic Title','Manage Units Gallery','Actions'],
    edit_form: {

      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },



        {
          label: 'Brochure',
          name: 'brochure',
          type: 'doc',
          value: '',
          required: true,
        },
        {
          label: 'Use Different Brochure for Arabic Version.',
          name: 'is_brochure_different',
          type: 'radio',
          value: '',
          required: false,
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },


      ],
      arabic: [

        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: false,
        },
        {
          label: 'Arabic Brochure',
          name: 'brochure_ar',
          type: 'doc',
          value: '',
          required: false,
        },
      ],
      hidden: [

      ],
      common: [],
    }, //end of edit faq
    add_form: {

      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },



        {
          label: 'Brochure',
          name: 'brochure',
          type: 'doc',
          value: '',
          required: true,
        },
        {
          label: 'Use Different Brochure for Arabic Version.',
          name: 'is_brochure_different',
          type: 'radio',
          value: '',
          required: false,
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },


      ],
      arabic: [

        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: false,
        },
        {
          label: 'Arabic Brochure',
          name: 'brochure_ar',
          type: 'doc',
          value: '',
          required: false,
        },
      ],
      hidden: [

      ],
      common: [],
    },
  },
  cali_units_gallery: {
    link: 'dashboard/cali_units/gallery/',
    getRecordLink: 'dashboard/cali_units_gallery/',
    postEditLink: 'dashboard/cali_units_gallery/update/',
    deleteLink: 'dashboard/cali_units_gallery',
    postAddLink: 'dashboard/cali_units_gallery',
    routerList: '/content-manager/list/cali_units_gallery/',
    title: 'Gallery',
    backLink: '/content-manager/list/cali_units_gallery/',
    hasBackLink: true,
    edit_title: 'Edit Gallery',
    delete_title: 'Delete Gallery',
    add_title: 'Add Gallery',
    hasArabic: true,
    hasCommon: false,
    hasHidden: true,
    hasAddButton: true,
    hasCategoryAdd:true,
    hasGroupButtons: false,
    hasDateSearch: false,
    hasExportButton: false,
    hasExportItem:false,
    columns: ['image','editPage'],
    titles: [ 'Image','Actions'],
    edit_form: {

      english: [


        {
          label: 'Image',
          name: 'image',
          type: 'file',
          value: '',
          required: true,
        },
        {
          label: 'Image Title',
          name: 'image_title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Use Different media for Arabic Version.',
          name: 'is_image_different',
          type: 'radio',
          value: '',
          required: false,
          related_to:['image','image_ar'],
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },

      ],
      arabic: [

        {
          label: 'Arabic Image',
          name: 'image_ar',
          type: 'file',
          value: '',
          required: false,
        },
        {
          label: 'Arabic Image Title',
          name: 'image_title_ar',
          type: 'text',
          value: '',
          required: false,
        },
      ],
      hidden: [
        {
          label: 'cali_unit_id',
          name: 'cali_unit_id',
          type: 'number',
          value: '',
          required: true,
        },
      ],
      common: [],
    }, //end of edit faq
    add_form: {

      english: [


        {
          label: 'Image',
          name: 'image',
          type: 'file',
          value: '',
          required: true,
        },
        {
          label: 'Image Title',
          name: 'image_title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Use Different media for Arabic Version.',
          name: 'is_image_different',
          type: 'radio',
          value: '',
          required: false,
          related_to:['image','image_ar'],
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },

      ],
      arabic: [
        {
          label: 'Arabic Image',
          name: 'image_ar',
          type: 'file',
          value: '',
          required: false,
        },
        {
          label: 'Arabic Image Title',
          name: 'image_title_ar',
          type: 'text',
          value: '',
          required: false,
        },
      ],
      hidden: [
        {
          label: 'cali_unit_id',
          name: 'cali_unit_id',
          type: 'number',
          value: '',
          required: true,
        },
      ],
      common: [],
    },
  },
  baymount_statistics:{

    link: 'dashboard/sections/',
    getRecordLink: 'dashboard/elements/',
    postEditLink: 'dashboard/elements/update/',
    deleteLink: 'dashboard/elements',
    postAddLink: 'dashboard/elements',
    backLink: '/content-manager/list/baymount_statistics/',
    routerList: '/content-manager/list/baymount_statistics/',
    hasBackLink: true,
    title: 'Slides',
    edit_title: 'Edit Slide',
    delete_title: 'Delete Slide',
    add_title: 'Add Slide',
    hasCommon: false,
    hasArabic: true,
    hasHidden: true,
    hasAddButton: false,
    hasCategoryAdd:false,
    hasGroupButtons: false,
    hasExportButton: false,
    columns: ['order','title','subtitle', 'title_ar', 'edit'],
    titles: ['order','Title', 'subtitle','Arabic Title', 'editPage'],
    edit_form: {

      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },

        {
          label: 'Subtitle',
          name: 'subtitle',
          type: 'text',
          value: '',
          required: true,
        },


      ],
      arabic: [
        //Edit of Venues
        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: false,
        },

        {
          label: 'Arabic Subtitle',
          name: 'subtitle_ar',
          type: 'text',
          value: '',
          required: false,
        },

      ],
      hidden: [
        {
          label: 'id',
          name: 'id',
          type: 'hidden',
          value: '',
          required: true,
        },

        {
          label: 'section_id',
          name: 'section_id',
          type: 'hidden',
          value: 66,
          required: true,
        },
      ],
      common: [],
    },
    add_form: {
      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Subtitle',
          name: 'subtitle',
          type: 'text',
          value: '',
          required: true,
        },


      ],
      arabic: [
        //Edit of Venues
        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: false,
        },

  {
          label: 'Arabic Subtitle',
          name: 'subtitle_ar',
          type: 'text',
          value: '',
          required: false,
        },

      ],
      hidden: [


        {
          label: 'section_id',
          name: 'section_id',
          type: 'hidden',
          value: 66,
          required: true,
        },
      ],
      common: [],
    },
  },
  baymount_map:{

    link: 'dashboard/sections/',
    getRecordLink: 'dashboard/elements/',
    postEditLink: 'dashboard/elements/update/',
    deleteLink: 'dashboard/elements',
    postAddLink: 'dashboard/elements',
    backLink: '/content-manager/list/baymount_map/',
    routerList: '/content-manager/list/baymount_map/',
    hasBackLink: true,
    title: 'Slides',
    edit_title: 'Edit Slide',
    delete_title: 'Delete Slide',
    add_title: 'Add Slide',
    hasCommon: false,
    hasArabic: true,
    hasHidden: true,
    hasAddButton: false,
    hasCategoryAdd:false,
    hasGroupButtons: false,
    hasExportButton: false,
    columns: ['order','title','subtitle', 'title_ar', 'edit'],
    titles: ['order','Title', 'subtitle','Arabic Title', 'editPage'],
    edit_form: {

      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },

        {
          label: 'Subtitle',
          name: 'subtitle',
          type: 'text',
          value: '',
          required: true,
        },


      ],
      arabic: [
        //Edit of Venues
        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: false,
        },

        {
          label: 'Arabic Subtitle',
          name: 'subtitle_ar',
          type: 'text',
          value: '',
          required: false,
        },

      ],
      hidden: [
        {
          label: 'id',
          name: 'id',
          type: 'hidden',
          value: '',
          required: true,
        },

        {
          label: 'section_id',
          name: 'section_id',
          type: 'hidden',
          value: 70,
          required: true,
        },
      ],
      common: [],
    },
    add_form: {
      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Subtitle',
          name: 'subtitle',
          type: 'text',
          value: '',
          required: true,
        },


      ],
      arabic: [
        //Edit of Venues
        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: false,
        },

  {
          label: 'Arabic Subtitle',
          name: 'subtitle_ar',
          type: 'text',
          value: '',
          required: false,
        },

      ],
      hidden: [


        {
          label: 'section_id',
          name: 'section_id',
          type: 'hidden',
          value: 70,
          required: true,
        },
      ],
      common: [],
    },
  },
  baymount_masterplan:{

    link: 'dashboard/sections/',
    getRecordLink: 'dashboard/elements/',
    postEditLink: 'dashboard/elements/update/',
    deleteLink: 'dashboard/elements',
    postAddLink: 'dashboard/elements',
    backLink: '/content-manager/list/baymount_masterplan/',
    routerList: '/content-manager/list/baymount_masterplan/',
    hasBackLink: true,
    title: 'Slides',
    edit_title: 'Edit Slide',
    delete_title: 'Delete Slide',
    add_title: 'Add Slide',
    hasCommon: false,
    hasArabic: true,
    hasHidden: true,
    hasAddButton: true,
    hasCategoryAdd:true,
    hasGroupButtons: false,
    hasExportButton: false,
    columns: ['order','title', 'media', 'editPage'],
    titles: ['order','title','media', 'actions'],
    edit_form: {

      english: [
        {
          label: 'Order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Subtitle',
          name: 'subtitle',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Description',
          name: 'description',
          type: 'textarea',
          value: '',
          required: true,
        },

        {
          label: 'Image',
          name: 'media',
          type: 'file',
          value: '',
          required: true,
        },
        {
          label: 'Media Title',
          name: 'media_title',
          type: 'text',
          value: '',
          required: true,
        },
       
        {
          label: 'Small Image',
          name: 'icon',
          type: 'file',
          value: '',
          required: true,
        },
        
        {
          label: 'Map',
          name: 'dark_image',
          type: 'file',
          value: '',
          required: true,
        },
      ],
      arabic: [
        //Edit of Venues
        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Arabic Subtitle',
          name: 'subtitle_ar',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Arabic Description',
          name: 'description_ar',
          type: 'textarea',
          value: '',
          required: true,
        },
        {
          label: 'Arabic Media Title',
          name: 'media_title_ar',
          type: 'text',
          value: '',
          required: true,
        },

      ],
      hidden: [
        {
          label: 'section_id',
          name: 'section_id',
          type: 'hidden',
          value: 73,
          required: true,
        },
      ],
      common: [],
    },
    add_form: {

      english: [
        {
          label: 'Order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Subtitle',
          name: 'subtitle',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Description',
          name: 'description',
          type: 'textarea',
          value: '',
          required: true,
        },

        {
          label: 'Image',
          name: 'media',
          type: 'file',
          value: '',
          required: true,
        },
        {
          label: 'Media Title',
          name: 'media_title',
          type: 'text',
          value: '',
          required: true,
        },
       
        {
          label: 'Small Image',
          name: 'icon',
          type: 'file',
          value: '',
          required: true,
        },
        
        {
          label: 'Map',
          name: 'dark_image',
          type: 'file',
          value: '',
          required: true,
        },
      ],
      arabic: [
        //Edit of Venues
        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Arabic Subtitle',
          name: 'subtitle_ar',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Arabic Description',
          name: 'description_ar',
          type: 'textarea',
          value: '',
          required: true,
        },
        {
          label: 'Arabic Media Title',
          name: 'media_title_ar',
          type: 'text',
          value: '',
          required: true,
        },

      ],
      hidden: [
        {
          label: 'section_id',
          name: 'section_id',
          type: 'hidden',
          value: 73,
          required: true,
        },
      ],
      common: [],
    },
  },
  baymount_partners:{

    link: 'dashboard/sections/',
    getRecordLink: 'dashboard/elements/',
    postEditLink: 'dashboard/elements/update/',
    deleteLink: 'dashboard/elements',
    postAddLink: 'dashboard/elements',
    backLink: '/content-manager/list/baymount_partners/',
    routerList: '/content-manager/list/baymount_partners/',
    hasBackLink: true,
    title: 'Slides',
    edit_title: 'Edit Slide',
    delete_title: 'Delete Slide',
    add_title: 'Add Slide',
    hasCommon: false,
    hasArabic: true,
    hasHidden: true,
    hasAddButton: true,
    hasCategoryAdd:true,
    hasGroupButtons: false,
    hasExportButton: false,
    maxLength: 12,
    columns: ['order','title', 'title_ar', 'icon', 'editPage'],
    titles: ['order','Title', 'Arabic Title', 'icon', 'editPage'],
    edit_form: {

      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Logo',
          name: 'icon',
          type: 'file',
          value: '',
          required: true,
        },
 {
          label: 'Use Different Logo for Arabic Version.',
          name: 'is_icon_different',
          type: 'radio',
          value: '',
          related_to:['icon','icon_ar'],
          required: false,
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },
        {
          label: 'Media Title',
          name: 'media_title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Link',
          name: 'url',
          type: 'text',
          value: '',
          required: true,
        },

      ],
      arabic: [
        //Edit of Venues
        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: true,
        },

        {
          label: 'Arabic Logo',
          name: 'icon_ar',
          type: 'file',
          value: '',
          required: false,
        },

      ],
      hidden: [
        {
          label: 'id',
          name: 'id',
          type: 'hidden',
          value: '',
          required: true,
        },

        {
          label: 'section_id',
          name: 'section_id',
          type: 'hidden',
          value: 74,
          required: true,
        },
      ],
      common: [],
    },
    add_form: {
      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Logo',
          name: 'icon',
          type: 'file',
          value: '',
          required: true,
        },
 {
          label: 'Use Different Logo for Arabic Version.',
          name: 'is_icon_different',
          type: 'radio',
          value: '',
          related_to:['icon','icon_ar'],
          required: false,
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },
        {
          label: 'Media Title',
          name: 'media_title',
          type: 'text',
          value: '',
          required: true,
        },

        {
          label: 'Link',
          name: 'url',
          type: 'text',
          value: '',
          required: true,
        },
      ],
      arabic: [
        //Edit of Venues
        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: false,
        },

        {
          label: 'Arabic Logo',
          name: 'icon_ar',
          type: 'file',
          value: '',
          required: false,
        },

      ],
      hidden: [


        {
          label: 'section_id',
          name: 'section_id',
          type: 'hidden',
          value: 74,
          required: true,
        },
      ],
      common: [],
    },
  },
  baymount_inquiry_unit:{

    link: 'dashboard/sections/',
    getRecordLink: 'dashboard/elements/',
    postEditLink: 'dashboard/elements/update/',
    deleteLink: 'dashboard/elements',
    postAddLink: 'dashboard/elements',
    backLink: '/content-manager/list/baymount_inquiry_unit/',
    routerList: '/content-manager/list/baymount_inquiry_unit/',
    hasBackLink: true,
    title: 'Slides',
    edit_title: 'Edit Slide',
    delete_title: 'Delete Slide',
    add_title: 'Add Slide',
    hasCommon: false,
    hasArabic: true,
    hasHidden: true,
    hasAddButton: true,
    hasCategoryAdd:true,
    hasGroupButtons: false,
    hasExportButton: false,
    columns: ['order','title', 'title_ar', 'editPage'],
    titles: ['order','Title', 'Arabic Title', 'editPage'],
    edit_form: {

      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },




      ],
      arabic: [
        //Edit of Venues
        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: false,
        },



      ],
      hidden: [
        {
          label: 'id',
          name: 'id',
          type: 'hidden',
          value: '',
          required: true,
        },

        {
          label: 'section_id',
          name: 'section_id',
          type: 'hidden',
          value: 78,
          required: true,
        },
      ],
      common: [],
    },
    add_form: {
      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },



      ],
      arabic: [
        //Edit of Venues
        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: false,
        },


      ],
      hidden: [


        {
          label: 'section_id',
          name: 'section_id',
          type: 'hidden',
          value:78,
          required: true,
        },
      ],
      common: [],
    },
  },
  baymount_inquiry_time:{

    link: 'dashboard/sections/',
    getRecordLink: 'dashboard/elements/',
    postEditLink: 'dashboard/elements/update/',
    deleteLink: 'dashboard/elements',
    postAddLink: 'dashboard/elements',
    backLink: '/content-manager/list/baymount_inquiry_unit/',
    routerList: '/content-manager/list/baymount_inquiry_unit/',
    hasBackLink: true,
    title: 'Slides',
    edit_title: 'Edit Slide',
    delete_title: 'Delete Slide',
    add_title: 'Add Slide',
    hasCommon: false,
    hasArabic: true,
    hasHidden: true,
    hasAddButton: true,
    hasCategoryAdd:false,
    hasGroupButtons: false,
    hasExportButton: false,
    columns: ['order','title', 'title_ar', 'editPage'],
    titles: ['order','Title', 'Arabic Title', 'editPage'],
    edit_form: {

      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },




      ],
      arabic: [
        //Edit of Venues
        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: false,
        },



      ],
      hidden: [
        {
          label: 'id',
          name: 'id',
          type: 'hidden',
          value: '',
          required: true,
        },

        {
          label: 'section_id',
          name: 'section_id',
          type: 'hidden',
          value: 79,
          required: true,
        },
      ],
      common: [],
    },
    add_form: {
      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },



      ],
      arabic: [
        //Edit of Venues
        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: false,
        },


      ],
      hidden: [


        {
          label: 'section_id',
          name: 'section_id',
          type: 'hidden',
          value:79,
          required: true,
        },
      ],
      common: [],
    },
  },
  baymount_units: {
    link: 'dashboard/baymount_units',
    getRecordLink: 'dashboard/baymount_units/',
    postEditLink: 'dashboard/baymount_units/update/',
    deleteLink: 'dashboard/baymount_units',
    postAddLink: 'dashboard/baymount_units',
    routerList: '/content-manager/baymount_units',
    title: 'Baymount Units',
    backLink: '/content-manager/baymount_units',
    hasBackLink: true,
    edit_title: 'Edit unit',
    delete_title: 'Delete unit',
    add_title: 'Add unit',
    hasArabic: true,
    hasCommon: false,
    hasHidden: true,
    hasAddButton: true,
    hasCategoryAdd:true,
    hasGroupButtons: false,
    hasDateSearch: false,
    hasExportButton: false,
    hasExportItem:false,
    columns: ['order','title', 'title_ar','manage_baymount_units','editPage'],
    titles: ['Order' , 'Title', 'Arabic Title','Manage Units Gallery','Actions'],
    edit_form: {

      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },



        {
          label: 'Brochure',
          name: 'brochure',
          type: 'doc',
          value: '',
          required: true,
        },
        {
          label: 'Use Different Brochure for Arabic Version.',
          name: 'is_brochure_different',
          type: 'radio',
          value: '',
          required: false,
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },


      ],
      arabic: [

        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: false,
        },
        {
          label: 'Arabic Brochure',
          name: 'brochure_ar',
          type: 'doc',
          value: '',
          required: false,
        },
      ],
      hidden: [

      ],
      common: [],
    }, //end of edit faq
    add_form: {

      english: [
        {
          label: 'order',
          name: 'order',
          type: 'number',
          value: '',
          required: true,
        },
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },



        {
          label: 'Brochure',
          name: 'brochure',
          type: 'doc',
          value: '',
          required: true,
        },
        {
          label: 'Use Different Brochure for Arabic Version.',
          name: 'is_brochure_different',
          type: 'radio',
          value: '',
          required: false,
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },


      ],
      arabic: [

        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: false,
        },
        {
          label: 'Arabic Brochure',
          name: 'brochure_ar',
          type: 'doc',
          value: '',
          required: false,
        },
      ],
      hidden: [

      ],
      common: [],
    },
  },
  baymount_units_gallery: {
    link: 'dashboard/baymount_units/gallery/',
    getRecordLink: 'dashboard/baymount_units_gallery/',
    postEditLink: 'dashboard/baymount_units_gallery/update/',
    deleteLink: 'dashboard/baymount_units_gallery',
    postAddLink: 'dashboard/baymount_units_gallery',
    routerList: '/content-manager/list/baymount_units_gallery/',
    title: 'Gallery',
    backLink: '/content-manager/list/baymount_units_gallery/',
    hasBackLink: true,
    edit_title: 'Edit Gallery',
    delete_title: 'Delete Gallery',
    add_title: 'Add Gallery',
    hasArabic: true,
    hasCommon: false,
    hasHidden: true,
    hasAddButton: true,
    hasCategoryAdd:true,
    hasGroupButtons: false,
    hasDateSearch: false,
    hasExportButton: false,
    hasExportItem:false,
    columns: ['image','editPage'],
    titles: [ 'Image','Actions'],
    edit_form: {

      english: [


        {
          label: 'Image',
          name: 'image',
          type: 'file',
          value: '',
          required: true,
        },
        {
          label: 'Image Title',
          name: 'image_title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Use Different media for Arabic Version.',
          name: 'is_image_different',
          type: 'radio',
          value: '',
          required: false,
          related_to:['image','image_ar'],
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },

      ],
      arabic: [

        {
          label: 'Arabic Image',
          name: 'image_ar',
          type: 'file',
          value: '',
          required: false,
        },
        {
          label: 'Arabic Image Title',
          name: 'image_title_ar',
          type: 'text',
          value: '',
          required: false,
        },
      ],
      hidden: [
        {
          label: 'baymount_unit_id',
          name: 'baymount_unit_id',
          type: 'number',
          value: '',
          required: true,
        },
      ],
      common: [],
    }, //end of edit faq
    add_form: {

      english: [


        {
          label: 'Image',
          name: 'image',
          type: 'file',
          value: '',
          required: true,
        },
        {
          label: 'Image Title',
          name: 'image_title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Use Different media for Arabic Version.',
          name: 'is_image_different',
          type: 'radio',
          value: '',
          required: false,
          related_to:['image','image_ar'],
          options: [
            { key: 1, label: 'Yes' },
            { key: 0, label: 'No' },
          ],
        },

      ],
      arabic: [
        {
          label: 'Arabic Image',
          name: 'image_ar',
          type: 'file',
          value: '',
          required: false,
        },
        {
          label: 'Arabic Image Title',
          name: 'image_title_ar',
          type: 'text',
          value: '',
          required: false,
        },
      ],
      hidden: [
        {
          label: 'baymount_unit_id',
          name: 'baymount_unit_id',
          type: 'number',
          value: '',
          required: true,
        },
      ],
      common: [],
    },
  },

  offers: {
    link: 'dashboard/offers',
    getRecordLink: 'dashboard/offers/',
    postEditLink: 'dashboard/offers/update/',
    deleteLink: 'dashboard/offers',
    postAddLink: 'dashboard/offers',
    routerList: '/content-manager/offers',
    title: 'Offers',
    backLink: '/content-manager/offers',
    hasBackLink: true,
    edit_title: 'Edit offer',
    delete_title: 'Delete offer',
    add_title: 'Add offer',
    hasArabic: true,
    hasCommon: false,
    hasHidden: true,
    hasAddButton: true,
    hasCategoryAdd:false,
    hasGroupButtons: false,
    hasDateSearch: false,
    hasExportButton: false,
    hasExportItem:false,
    columns: ['order','title', 'page_details' , 'description','logo','image','editPage'],
    titles: ['order','Title',  'page Details' ,'description','logo','Image','Actions'],
    edit_form: {

      english: [
        {
          label: 'Order',
          name: 'order',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Description',
          name: 'description',
          type: 'textarea',
          value: '',
          required: false,
        },
        {
          label: 'Logo',
          name: 'logo',
          type: 'file',
          value: '',
          required: true,
        },
        {
          label: 'Image',
          name: 'image',
          type: 'file',
          value: '',
          required: true,
        },
        {
          label: 'Image Title',
          name: 'image_title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Button Type',
          name: 'button_type',
          type: 'button_type',
          value: '',
          required: true,
        },
        {
          label: 'Button Value',
          name: 'button_value',
          type: 'text',
          value: '',
          required: false,
        },
        {
          label: 'Button Content',
          name: 'button_content',
          type: 'text',
          value: '',
          required: false,
        },
      
    
        
      ],
      arabic: [
        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: false,
        },
        {
          label: 'Arabic Description',
          name: 'description_ar',
          type: 'textarea',
          value: '',
          required: false,
        },
       
        {
          label: 'Arabic Image Title',
          name: 'image_title_ar',
          type: 'text',
          value: '',
          required: false,
        },
        {
          label: 'Arabic Button Content',
          name: 'button_content_ar',
          type: 'text',
          value: '',
          required: false,
        },
      ],
      hidden: [
       
      ],
      common: [],
    }, //end of edit faq
    add_form: {

      english: [
        {
          label: 'Order',
          name: 'order',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Description',
          name: 'description',
          type: 'textarea',
          value: '',
          required: false,
        },
        {
          label: 'Logo',
          name: 'logo',
          type: 'file',
          value: '',
          required: true,
        },
        {
          label: 'Image',
          name: 'image',
          type: 'file',
          value: '',
          required: true,
        },
        {
          label: 'Image Title',
          name: 'image_title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Button Type',
          name: 'button_type',
          type: 'button_type',
          value: '',
          required: true,
        },
        {
          label: 'Button Value',
          name: 'button_value',
          type: 'text',
          value: '',
          required: false,
        },
        
       {
          label: 'Button Content',
          name: 'button_content',
          type: 'text',
          value: '',
          required: false,
        },
      
    
        
      ],
      arabic: [
        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: false,
        },
        {
          label: 'Arabic Description',
          name: 'description_ar',
          type: 'textarea',
          value: '',
          required: false,
        },
       
        {
          label: 'Arabic Image Title',
          name: 'image_title_ar',
          type: 'text',
          value: '',
          required: false,
        },
       {
          label: 'Arabic Button Content',
          name: 'button_content_ar',
          type: 'text',
          value: '',
          required: false,
        },
      ],
      hidden: [
       
      ],
      common: [],
    },
  },
  axa_benefits: {
    link: 'dashboard/offers_sections/',
    getRecordLink: 'dashboard/offers_elements/',
    postEditLink: 'dashboard/offers_elements/update/',
    deleteLink: 'dashboard/offers_elements',
    postAddLink: 'dashboard/offers_elements',
    routerList: '/content-manager/list/axa_benefits/',
    title: 'Axa Benefits',
    backLink: '/content-manager/list/axa_benefits/',
    hasBackLink: true,
    edit_title: 'Edit offer',
    delete_title: 'Delete offer',
    add_title: 'Add',
    hasArabic: true,
    hasCommon: false,
    hasHidden: true,
    hasAddButton: true,
    hasCategoryAdd:true,
    hasGroupButtons: false,
    hasDateSearch: false,
    hasExportButton: false,
    hasExportItem:false,
    columns: ['order','title' ,'media','editPage'],
    titles: ['order','Title','media','Actions'],
    edit_form: {

      english: [
        {
          label: 'Order',
          name: 'order',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Description',
          name: 'description',
          type: 'textarea',
          value: '',
          required: false,
        },
      
        {
          label: 'Media',
          name: 'media',
          type: 'file',
          value: '',
          required: true,
        },
        {
          label: 'Media Title',
          name: 'media_title',
          type: 'text',
          value: '',
          required: true,
        },
       
       
      
    
        
      ],
      arabic: [
        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: false,
        },
        {
          label: 'Arabic Description',
          name: 'description_ar',
          type: 'textarea',
          value: '',
          required: false,
        },
       
        {
          label: 'Arabic Media Title',
          name: 'media_title_ar',
          type: 'text',
          value: '',
          required: false,
        },
       
      ],
      hidden: [
        {
          label: 'offers_section_id',
          name: 'offers_section_id',
          type: 'hidden',
          value: '',
          required: false,
        },
        
      ],
      common: [],
    }, //end of edit faq
    add_form: {

      english: [
        {
          label: 'Order',
          name: 'order',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Description',
          name: 'description',
          type: 'textarea',
          value: '',
          required: false,
        },
      
        {
          label: 'Media',
          name: 'media',
          type: 'file',
          value: '',
          required: true,
        },
        {
          label: 'Media Title',
          name: 'media_title',
          type: 'text',
          value: '',
          required: true,
        },
       
       
      
    
        
      ],
      arabic: [
        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: false,
        },
        {
          label: 'Arabic Description',
          name: 'description_ar',
          type: 'textarea',
          value: '',
          required: false,
        },
       
        {
          label: 'Arabic Media Title',
          name: 'media_title_ar',
          type: 'text',
          value: '',
          required: false,
        },
       
      ],
      hidden: [
        {
          label: 'offers_section_id',
          name: 'offers_section_id',
          type: 'hidden',
          value: '',
          required: false,
        },
      ],
      common: [],
    },
  },
  axa_additional_services: {
    link: 'dashboard/offers_sections/',
    getRecordLink: 'dashboard/offers_elements/',
    postEditLink: 'dashboard/offers_elements/update/',
    deleteLink: 'dashboard/offers_elements',
    postAddLink: 'dashboard/offers_elements',
    routerList: '/content-manager/list/axa_additional_services/',
    title: 'Additional Services',
    backLink: '/content-manager/list/axa_additional_services/',
    hasBackLink: true,
    edit_title: 'Edit offer',
    delete_title: 'Delete offer',
    add_title: 'Add',
    hasArabic: true,
    hasCommon: false,
    hasHidden: true,
    hasAddButton: true,
    hasCategoryAdd:true,
    hasGroupButtons: false,
    hasDateSearch: false,
    hasExportButton: false,
    hasExportItem:false,
    columns: ['order','title' ,'media','editPage'],
    titles: ['order','Title', 'media','Actions'],
    edit_form: {

      english: [
        {
          label: 'Order',
          name: 'order',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },
       
      
        {
          label: 'Media',
          name: 'media',
          type: 'file',
          value: '',
          required: true,
        },
        {
          label: 'Media Title',
          name: 'media_title',
          type: 'text',
          value: '',
          required: true,
        },
       
       
      
    
        
      ],
      arabic: [
        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: false,
        },
       
       
        {
          label: 'Arabic Media Title',
          name: 'media_title_ar',
          type: 'text',
          value: '',
          required: false,
        },
       
      ],
      hidden: [
        {
          label: 'offers_section_id',
          name: 'offers_section_id',
          type: 'hidden',
          value: '',
          required: false,
        },
        
      ],
      common: [],
    }, //end of edit faq
    add_form: {

      english: [
        {
          label: 'Order',
          name: 'order',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },
       
      
        {
          label: 'Media',
          name: 'media',
          type: 'file',
          value: '',
          required: true,
        },
        {
          label: 'Media Title',
          name: 'media_title',
          type: 'text',
          value: '',
          required: true,
        },
       
       
      
    
        
      ],
      arabic: [
        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: false,
        },
       
       
        {
          label: 'Arabic Media Title',
          name: 'media_title_ar',
          type: 'text',
          value: '',
          required: false,
        },
       
      ],
      hidden: [
        {
          label: 'offers_section_id',
          name: 'offers_section_id',
          type: 'hidden',
          value: '',
          required: false,
        },
      ],
      common: [],
    },
  },
  axa_inquiry_projects: {
    link: 'dashboard/offers_sections/',
    getRecordLink: 'dashboard/offers_elements/',
    postEditLink: 'dashboard/offers_elements/update/',
    deleteLink: 'dashboard/offers_elements',
    postAddLink: 'dashboard/offers_elements',
    routerList: '/content-manager/list/axa_inquiry_projects/',
    title: 'Inquiry Projects',
    backLink: '/content-manager/list/axa_inquiry_projects/',
    hasBackLink: true,
    edit_title: 'Edit offer',
    delete_title: 'Delete offer',
    add_title: 'Add',
    hasArabic: true,
    hasCommon: false,
    hasHidden: true,
    hasAddButton: true,
    hasCategoryAdd:true,
    hasGroupButtons: false,
    hasDateSearch: false,
    hasExportButton: false,
    hasExportItem:false,
    columns: ['order','title' ,'editPage'],
    titles: ['order','Title','Actions'],
    edit_form: {

      english: [
        {
          label: 'Order',
          name: 'order',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },
       
      
      
       
       
      
    
        
      ],
      arabic: [
        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: false,
        },
       
       
       
      ],
      hidden: [
        {
          label: 'offers_section_id',
          name: 'offers_section_id',
          type: 'hidden',
          value: '',
          required: false,
        },
        
      ],
      common: [],
    }, //end of edit faq
    add_form: {

      english: [
        {
          label: 'Order',
          name: 'order',
          type: 'text',
          value: '',
          required: true,
        },
        {
          label: 'Title',
          name: 'title',
          type: 'text',
          value: '',
          required: true,
        },
       
      
      
       
      
    
        
      ],
      arabic: [
        {
          label: 'Arabic Title',
          name: 'title_ar',
          type: 'text',
          value: '',
          required: false,
        },
       
       
      
       
      ],
      hidden: [
        {
          label: 'offers_section_id',
          name: 'offers_section_id',
          type: 'hidden',
          value: '',
          required: false,
        },
      ],
      common: [],
    },
  },
offers_inquiries: {
  //faq
  link: 'dashboard/offers_inquiries',
  searchlink: 'dashboard/offers_inquiries/search',
  getRecordLink: 'dashboard/offers_inquiries',
  postEditLink: 'dashboard/offers_inquiries/update',
  deleteLink: 'dashboard/offers_inquiries',
  postAddLink: 'dashboard/offers_inquiries',
  routerList: '/content-manager/offers_inquiries',
  title: 'Offers Inquiries',
  backLink: '/content-manager/offers_inquiries',
  hasBackLink: true,
  edit_title: 'Edit inquiry',
  delete_title: 'Delete',
  add_title: 'Add Inquiry',
  hasArabic: false,
  hasCommon: false,
  hasHidden: false,
  hasAddButton: false,
  hasFilter:true,
  hasGroupButtons: false,
  hasDateSearch: true,
  hasExportButton: true,
  hasExportItem: false,
  exportOptions: {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalseparator: '.',
    showLabels: false,
    showTitle: false,
    useBom: true,
    headers: [
      'id',
      'name',
      'email',
      'phone',
      'unit Number',
      'message',
      'project',
      'offer',
      'created_at',

    ],
  },
  columns: [
    'number',
    'name',
    'email',
    'phone',
    'unit_number',
    'offer',
    'project',
    'message',
    'created_at',
    'delete',
  ],
  titles: [
    'number',
    'name',
    'email',
    'phone',
    'unit number',
    'offer',
    'project',
    'message',
    'created at',
    'Action',
  ],
},    
    
customer_care_phone: {
  link: 'dashboard/sections/',
  getRecordLink: 'dashboard/elements/',
  postEditLink: 'dashboard/elements/update/',
  deleteLink: 'dashboard/elements',
  postAddLink: 'dashboard/elements',
  routerList: '/content-manager/list/customer_care_phone/',
  title: 'Customer Care Phones',
  backLink: '/content-manager/list/customer_care_phone/',
  hasBackLink: true,
  edit_title: 'Edit',
  delete_title: 'Delete',
  add_title: 'Add',
  hasArabic: true,
  hasCommon: false,
  hasHidden: true,
  hasAddButton: true,
  hasCategoryAdd:true,
  hasGroupButtons: false,
  hasDateSearch: false,
  hasExportButton: false,
  hasExportItem:false,
  columns: ['order','title' ,'subtitle','editPage'],
  titles: ['order','Title','subtitle','Actions'],
  edit_form: {

    english: [
      {
        label: 'Order',
        name: 'order',
        type: 'text',
        value: '',
        required: true,
      },
      {
        label: 'Name',
        name: 'title',
        type: 'text',
        value: '',
        required: true,
      },
      {
        label: 'Phone',
        name: 'subtitle',
        type: 'text',
        value: '',
        required: true,
      },
    
    
     
     
    
  
      
    ],
    arabic: [
      {
        label: 'Arabic Name',
        name: 'title_ar',
        type: 'text',
        value: '',
        required: false,
      },
      {
        label: 'Phone',
        name: 'subtitle_ar',
        type: 'text',
        value: '',
        required: true,
      },
     
     
    ],
    hidden: [
      {
        label: 'section_id',
        name: 'section_id',
        type: 'hidden',
        value: '',
        required: false,
      },
      
    ],
    common: [],
  }, //end of edit faq
  add_form: {

    english: [
      {
        label: 'Order',
        name: 'order',
        type: 'text',
        value: '',
        required: true,
      },
      {
        label: 'Name',
        name: 'title',
        type: 'text',
        value: '',
        required: true,
      },
      {
        label: 'Phone',
        name: 'subtitle',
        type: 'text',
        value: '',
        required: true,
      },
    
    
     
    
  
      
    ],
    arabic: [
      {
        label: 'Arabic Name',
        name: 'title_ar',
        type: 'text',
        value: '',
        required: false,
      },
      {
        label: 'Phone',
        name: 'subtitle_ar',
        type: 'text',
        value: '',
        required: true,
      },
     
     
    
     
    ],
    hidden: [
      {
        label: 'section_id',
        name: 'section_id',
        type: 'hidden',
        value: '',
        required: false,
      },
    ],
    common: [],
  },
},
offers_inquiry_project: {
  link: 'dashboard/sections/',
  getRecordLink: 'dashboard/elements/',
  postEditLink: 'dashboard/elements/update/',
  deleteLink: 'dashboard/elements',
  postAddLink: 'dashboard/elements',
  routerList: '/content-manager/list/offers_inquiry_project/',
  title: 'Projects',
  backLink: '/content-manager/list/offers_inquiry_project/',
  hasBackLink: true,
  edit_title: 'Edit',
  delete_title: 'Delete',
  add_title: 'Add',
  hasArabic: true,
  hasCommon: false,
  hasHidden: true,
  hasAddButton: true,
  hasCategoryAdd:true,
  hasGroupButtons: false,
  hasDateSearch: false,
  hasExportButton: false,
  hasExportItem:false,
  columns: ['order','title' ,'editPage'],
  titles: ['order','Title','Actions'],
  edit_form: {

    english: [
      {
        label: 'Order',
        name: 'order',
        type: 'text',
        value: '',
        required: true,
      },
      {
        label: 'Name',
        name: 'title',
        type: 'text',
        value: '',
        required: true,
      },
     
    
    
     
     
    
  
      
    ],
    arabic: [
      {
        label: 'Arabic Name',
        name: 'title_ar',
        type: 'text',
        value: '',
        required: false,
      },
    
     
     
    ],
    hidden: [
      {
        label: 'section_id',
        name: 'section_id',
        type: 'hidden',
        value: '',
        required: false,
      },
      
    ],
    common: [],
  }, //end of edit faq
  add_form: {

    english: [
      {
        label: 'Order',
        name: 'order',
        type: 'text',
        value: '',
        required: true,
      },
      {
        label: 'Name',
        name: 'title',
        type: 'text',
        value: '',
        required: true,
      },
     
    
    
     
    
  
      
    ],
    arabic: [
      {
        label: 'Arabic Name',
        name: 'title_ar',
        type: 'text',
        value: '',
        required: false,
      },
     
     
    
     
    ],
    hidden: [
      {
        label: 'section_id',
        name: 'section_id',
        type: 'hidden',
        value: '',
        required: false,
      },
    ],
    common: [],
  },
},
};

